import React, { Fragment, useState, useEffect, useRef } from "react";
import { MenuItem, Typography } from "@material-ui/core";
import { connect } from "react-redux";
import { currentRouteSet } from "../../actions/actions";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import {
  pathSpliter,
  checkAuthBranchWare,
  dateTimeFormat,
  checkIntNum,
  currentDateTime,
  getDateTimeFromISODT,
} from "../../lib/functions";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { APP_URL, API_URL } from "../../config";
import { useHistory, useParams } from "react-router-dom";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

import axios from "axios";
import SaveIcon from "@material-ui/icons/Save";
import Button from "@material-ui/core/Button";
import LoadingButton from "../commons/LoadingButton";
import EditIcon from "@material-ui/icons/Edit";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";

import DateFnsUtils from "@date-io/date-fns"; // choose your lib

import "./components/sale.css";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import {
  DatePicker,
  TimePicker,
  DateTimePicker,
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import swal from "sweetalert";
import { CardContent } from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";

import commaNumber from "comma-number";
import { use } from "react";
import {
  OFFLINE_SALES_SYNC_EVENT,
  STORAGE_KEYS,
  cacheSalesMasterData,
  loadSalesMasterData,
  enqueueOfflineSale,
  getOfflineQueueCount,
  syncOfflineSalesQueue,
} from "../../lib/offlineSales";
import { getOfflineValue, setOfflineValue, removeOfflineValue } from "../../lib/offlineIndexedDB";
let format = commaNumber.bindWith(",", ".");

const SalesEntry = ({ location, currentRoute, currentRouteSet, authInfo }) => {
  const classes = useStyles();
  const SALES_DRAFT_KEY = "salesEntryDraft";
  const SALES_CART_KEY = "salesCart";
  const SALES_STORAGE_CART_KEY = "salesStorageCart";
  const [selectedDate, handleDateChangeSet] = useState(currentDateTime);

  const history = useHistory();
  const { id: saleRouteId } = useParams();
  const saleRouteSaleId = Number.parseFloat(saleRouteId);
  const hasSaleRouteId = Number.isFinite(saleRouteSaleId);

  // States start
  // Initialize cart from localStorage
  let [cart, cartSet] = useState([]);

  let [storageCart, storageCartSet] = useState([]);

  let [employees, employeesSet] = useState([]);
  let [customers, customersSet] = useState([]);
  let [floors, floorsSet] = useState([]);
  let [racks, racksSet] = useState([]);
  let [contactPersons, contactPersonsSet] = useState([]);
  let [products, productsSet] = useState([]);
  let [allProducts, allProductsSet] = useState([]);

  const [floor, setFloor] = useState({ prod_floor_id: 0, prod_floor_name: "" });
  const [rack, setRack] = useState({ prod_rack_id: 0, prod_rack_name: "" });

  let [selectedEmployee, selectedEmployeeSet] = useState(null);
  let [selectedCustomer, selectedCustomerSet] = useState(null);
  let [selectedContactPerson, selectedContactPersonSet] = useState(null);
  let [selectedFloor, selectedFloorSet] = useState(null);
  let [selectedQuantity, selectedQuantitySet] = useState(null);
  let [selectedRack, selectedRackSet] = useState(null);
  let [selectedProduct, selectedProductSet] = useState(null);
  const [productSearchInput, setProductSearchInput] = useState("");
  const [productLookupLoading, setProductLookupLoading] = useState(false);
  const [locationRateOptions, setLocationRateOptions] = useState([]);
  const [selectedLocationRate, setSelectedLocationRate] = useState(null);
  const [floorStockSummary, setFloorStockSummary] = useState({
    productCount: 0,
    totalQty: 0,
    productNames: [],
    unitNames: [],
  });
  let [selectedId, selectedIdSet] = useState(null);

  let [saveAction, saveActionSet] = useState(false);

  let [customerPayAccs, customerPayAccsSet] = useState([]);
  let [customer_type, customer_type_set] = useState("retail");

  let [selectedCustomerPayMethod, selectedCustomerPayMethodSet] = useState(
    { pay_method_id: "cash", pay_method: "cash" }
  );
  let [selectedCustomerPayAcc, selectedCustomerPayAccSet] = useState(null);

  let [sale_invoice, sale_invoice_set] = useState("");
  let [po_id, po_id_set] = useState("");
  let [sale_emp_id, sale_emp_id_set] = useState(0);

  let [sale_created_isodt, sale_created_isodt_set] = useState("");

  let [customer_name, customer_name_set] = useState("");
  let [customer_mobile_no, customer_mobile_no_set] = useState("");
  let [customer_address, customer_address_set] = useState("");

  let [product_rate, product_rate_set] = useState(0);
  let [product_brand, product_brand_set] = useState("");
  let [product_floor, product_floor_set] = useState("");
  let [product_rack, product_rack_set] = useState("");
  let [product_color, product_color_set] = useState("");
  let [product_qty, product_qty_set] = useState("0");
  let [product_total, product_total_set] = useState(0);

  let [product_stock_status, product_stock_status_set] = useState("stock status");
  let [product_stock_qty, product_stock_qty_set] = useState("stock qty");
  let [product_total_stock_qty, product_total_stock_qty_set] = useState("stock qty");
  let [product_unit, product_unit_set] = useState("unit");
  let [product_purchase_rate, product_purchase_rate_set] = useState(0);

  let [general_customer, general_customer_set] = useState(false);

  let [note, note_set] = useState("");
  let [sub_total, sub_total_set] = useState(0);
  let [previous_due, previous_due_set] = useState(0);
  let [vat, vat_set] = useState(0);
  let [ait, ait_set] = useState(0);
  let [vat_percent, vat_percent_set] = useState(0);
  let [ait_percent, ait_percent_set] = useState(0);
  let [discount, discount_set] = useState(0);
  let [discount_percent, discount_percent_set] = useState(0);
  let [total_amount, total_amount_set] = useState(0);
  let [paid, paid_set] = useState(0);
  let [due, due_set] = useState(0);
  let [transport_cost, transport_cost_set] = useState(0);
  let [saleAction, saleActionSet] = useState("create");
  let [saleId, saleIdSet] = useState(0);
  let [enteredSetNo, enteredSetNoSet] = useState("");


  // --- keep track of which field user last edited (amount vs percent)
  const [vatMode, setVatMode] = useState("percent"); // "percent" | "amount"
  const [aitMode, setAitMode] = useState("percent"); // "percent" | "amount"
  const [discountMode, setDiscountMode] = useState("amount"); // "percent" | "amount"

  const num = (v) => {
    const x = parseFloat(v);
    return Number.isFinite(x) ? x : 0;
  };
  const round2 = (x) => Math.round((num(x) + Number.EPSILON) * 100) / 100;
  const decimalInputProps = { inputMode: "decimal" };
  const normalizeDecimalInput = (value) => {
    let next = String(value ?? "").replace(/[^\d.]/g, "");
    const firstDot = next.indexOf(".");

    if (firstDot !== -1) {
      next =
        next.slice(0, firstDot + 1) +
        next.slice(firstDot + 1).replace(/\./g, "");
    }

    if (next === "") return "";
    if (next.startsWith(".")) return `0${next}`;

    const [whole, fraction] = next.split(".");
    const normalizedWhole = whole.replace(/^0+(?=\d)/, "") || "0";

    return fraction === undefined
      ? normalizedWhole
      : `${normalizedWhole}.${fraction}`;
  };
  const normalizePurchaseRate = (value) => Number(num(value).toFixed(4));
  const normalizeText = (value) => String(value ?? "").trim().toLowerCase();
  const normalizeFloorId = (value) => Number(value || 0);
  const normalizeProductId = (value) => Number(value || 0);
  const normalizeProductSearchText = (value) =>
    String(value ?? "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  const getProductSearchParts = (product = {}) => [
    product?.prod_code,
    product?.prod_name,
    product?.prod_brand_name,
    product?.prod_brand,
    product?.brand_name,
    product?.prod_color_name,
    product?.prod_color,
    product?.prod_country_name,
    product?.country_name,
    product?.prod_cat_name,
    product?.prod_set_no,
    product?.entered_set_no,
    product?.prod_barcode,
    product?.barcode,
    product?.bar_code,
    product?.product_barcode,
  ].filter(Boolean);
  const getProductSearchRank = (product, inputValue) => {
    const queryTokens = normalizeProductSearchText(inputValue).split(" ").filter(Boolean);
    if (queryTokens.length === 0) return 0;

    const normalizedParts = getProductSearchParts(product).map(normalizeProductSearchText);
    const productTokens = normalizedParts.flatMap((part) => part.split(" ").filter(Boolean));
    const haystack = normalizedParts.join(" ");

    if (queryTokens.every((token) => productTokens.includes(token))) return 0;
    if (queryTokens.every((token) => productTokens.some((part) => part.startsWith(token)))) return 1;
    if (queryTokens.every((token) => normalizedParts.some((part) => part.startsWith(token)))) return 2;
    if (queryTokens.every((token) => haystack.includes(token))) return 3;

    return Number.POSITIVE_INFINITY;
  };
  const sortProductsBySearchInput = (options, inputValue) =>
    options
      .map((option, index) => ({
        option,
        index,
        rank: getProductSearchRank(option, inputValue),
      }))
      .filter((item) => Number.isFinite(item.rank))
      .sort((a, b) => a.rank - b.rank || a.index - b.index)
      .map((item) => item.option);
  const mergeUniqueProducts = (...groups) => {
    const map = new Map();

    groups.flat().forEach((product) => {
      const productId = normalizeProductId(product?.prod_id);
      if (!productId || map.has(productId)) return;
      map.set(productId, product);
    });

    return Array.from(map.values());
  };
  const getProductNameParts = (product = {}) =>
    String(product?.prod_name || "")
      .split(" - ")
      .map((part) => part.trim())
      .filter(Boolean);
  const getProductBrandName = (product = {}) =>
    product?.prod_brand_name ||
    product?.prod_brand ||
    product?.brand_name ||
    product?.brand ||
    getProductNameParts(product)[1] ||
    "";
  const getProductCountryName = (product = {}) =>
    product?.prod_color_name ||
    product?.prod_color ||
    product?.prod_country_name ||
    product?.prod_country ||
    product?.country_name ||
    product?.country ||
    getProductNameParts(product)[2] ||
    "";
  const getLocationRateKey = (item) =>
    [
      Number(item?.prod_id || 0),
      Number(item?.prod_floor_id || 0),
      Number(item?.prod_rack_id || 0),
      normalizePurchaseRate(item?.prod_purchase_rate ?? item?.average_purchase_rate ?? 0).toFixed(4),
    ].join("||");
  const mapSaleDetailToCartItem = (ele = {}) => ({
    prod_id: ele.sale_prod_id || ele.prod_id || ele.pur_prod_id || 0,
    prod_code: ele.prod_code || "",
    prod_name: ele.prod_name || "",
    prod_sale_rate: ele.sale_rate || ele.prod_sale_rate || ele.prod_rate || 0,
    prod_brand: ele.prod_brand || ele.prod_brand_name || "",
    prod_brand_name: ele.prod_brand_name || ele.prod_brand || "",
    prod_color: ele.prod_color || ele.prod_color_name || "",
    prod_color_name: ele.prod_color_name || ele.prod_color || "",
    prod_floor: ele.sale_prod_floor || ele.prod_floor_id || 0,
    prod_floor_name: ele.prod_floor_name || "",
    prod_rack: ele.sale_prod_rack || ele.prod_rack_id || 0,
    prod_rack_name: ele.prod_rack_name || "",
    prod_qty: ele.sale_qty || ele.prod_qty || ele.pur_qty || ele.po_qty || 0,
    prod_purchase_rate: ele.sale_prod_purchase_rate || ele.prod_purchase_rate || 0,
    prod_total: ele.sale_prod_total || ele.prod_total || 0,
    prod_unit_name: ele.prod_unit_name || "",
    prod_set_no: ele.prod_set_no || "",
    prod_set_qty: ele.prod_set_qty || ele.set_qty || "",
    entered_set_no: ele.entered_set_no || "",
    storage_batch_id: ele.storage_batch_id ?? 0,
    prod_stock_qty: ele.prod_stock_qty ?? 0,
  });
  const hydrateEditorFromCartItem = (target) => {
    if (!target) return;

    setPreserveLocationOnProductChange(true);
    selectedProductSet({
      prod_id: target.prod_id || 0,
      prod_code: target.prod_code || "",
      prod_name: target.prod_name || "",
      prod_purchase_rate: target.prod_purchase_rate || 0,
      prod_sale_rate: target.prod_sale_rate || 0,
      prod_rate: target.prod_sale_rate || 0,
      prod_brand_name: target.prod_brand_name || target.prod_brand || "",
      prod_color_name: target.prod_color_name || target.prod_color || "",
      prod_floor_id: target.prod_floor || 0,
      prod_floor_name: target.prod_floor_name || "",
      prod_rack_id: target.prod_rack || 0,
      prod_rack_name: target.prod_rack_name || "",
      prod_unit_name: target.prod_unit_name || "",
      prod_set_no: target.prod_set_no || "",
      prod_set_qty: target.prod_set_qty || "",
    });
    product_rate_set(target.prod_sale_rate || 0);
    product_brand_set(target.prod_brand || target.prod_brand_name || "");
    product_color_set(target.prod_color || target.prod_color_name || "");
    selectedFloorSet(
      target.prod_floor
        ? {
            prod_floor_id: target.prod_floor,
            prod_floor_name: target.prod_floor_name || "",
          }
        : null
    );
    selectedRackSet(
      target.prod_rack
        ? {
            prod_rack_id: target.prod_rack,
            prod_rack_name: target.prod_rack_name || "",
          }
        : null
    );
    product_purchase_rate_set(target.prod_purchase_rate || 0);
    product_qty_set(target.prod_qty || "");
    product_total_set(target.prod_total || 0);
    enteredSetNoSet(target.entered_set_no || "");
    selectedIdSet(target.prod_id || null);
  };
  const groupLocationRateRows = (rows, floorId, rackId) => {
    const map = new Map();
    const normalizedFloorId = Number(floorId || 0);
    const normalizedRackId = Number(rackId || 0);

    (Array.isArray(rows) ? rows : []).forEach((row) => {
      if (Number(row?.prod_floor_id || 0) !== normalizedFloorId) return;
      if (Number(row?.prod_rack_id || 0) !== normalizedRackId) return;

      const key = getLocationRateKey(row);
      const existing = map.get(key);
      const currentQty = num(row?.prod_qty || row?.current_stock || 0);
      const purchaseRate = normalizePurchaseRate(
        row?.prod_purchase_rate ?? row?.average_purchase_rate ?? row?.sale_prod_purchase_rate ?? 0
      );

      if (existing) {
        const mergedQty = num(existing.prod_qty) + currentQty;
        map.set(key, {
          ...existing,
          prod_qty: mergedQty,
          current_quantity: mergedQty,
          current_stock: mergedQty,
          prod_purchase_rate: purchaseRate,
          stock_value: round2(mergedQty * purchaseRate),
        });
        return;
      }

      map.set(key, {
        ...row,
        prod_qty: currentQty,
        current_quantity: currentQty,
        current_stock: currentQty,
        prod_purchase_rate: purchaseRate,
        average_purchase_rate: row?.average_purchase_rate ?? purchaseRate,
        stock_value: round2(currentQty * purchaseRate),
      });
    });

    return Array.from(map.values()).sort(
      (a, b) => normalizePurchaseRate(a.prod_purchase_rate) - normalizePurchaseRate(b.prod_purchase_rate)
    );
  };

  const getRowStockQty = (row) =>
    num(
      row?.prod_qty ??
      row?.current_stock ??
      row?.stock_qty ??
      row?.current_quantity ??
      row?.total_stock ??
      0
    );

  const buildFloorStockSummary = (floorItem, productRows = [], locationRows = []) => {
    if (!floorItem?.prod_floor_id) {
      return { productCount: 0, totalQty: 0, productNames: [], unitNames: [] };
    }

    const floorId = normalizeFloorId(floorItem.prod_floor_id);
    const floorName = normalizeText(floorItem.prod_floor_name);
    const productMap = new Map();
    const unitNames = new Set();

    const includeLocationRow = (row) => {
      const rowFloorId = normalizeFloorId(row?.prod_floor_id ?? row?.sale_prod_floor);
      const rowFloorName = normalizeText(row?.prod_floor_name);
      return rowFloorId === floorId || (floorName && rowFloorName === floorName);
    };

    const addRow = (row) => {
      const productId = Number(row?.prod_id || row?.sale_prod_id || row?.pur_prod_id || 0);
      const productName = String(row?.prod_name || row?.product_name || "").trim();
      const key = productId || productName;
      if (!key) return;

      const existing = productMap.get(key) || {
        name: productName || `Product ${productId}`,
        qty: 0,
      };
      existing.qty += getRowStockQty(row);
      productMap.set(key, existing);

      const unitName = String(row?.prod_unit_name || row?.unit_name || "").trim();
      if (unitName) unitNames.add(unitName);
    };

    (Array.isArray(locationRows) ? locationRows : [])
      .filter(includeLocationRow)
      .forEach(addRow);

    if (productMap.size === 0) {
      (Array.isArray(productRows) ? productRows : []).forEach(addRow);
    }

    const products = Array.from(productMap.values());
    return {
      productCount: products.length,
      totalQty: round2(products.reduce((sum, item) => sum + num(item.qty), 0)),
      productNames: products.map((item) => item.name).filter(Boolean).slice(0, 3),
      unitNames: Array.from(unitNames).slice(0, 2),
    };
  };

  const applyCustomerTypeRates = (list, type = customer_type) =>
    (list || []).map((prod) => ({
      ...prod,
      prod_rate: type == "wholesale" ? prod.prod_whole_sale_rate : prod.prod_sale_rate,
    }));

  const [selectedLocation, setSelectedLocation] = useState("");
  let [customer_credit_limit, customer_credit_limit_set] = useState(0);
  let customerPayMethods = [
    { pay_method_id: "cash", pay_method: "cash" },
    { pay_method_id: "bank", pay_method: "bank" },
  ];
  const [resetKey, setResetKey] = useState(0);
  const [editCartIndex, editCartIndexSet] = useState(null);
  const [preserveLocationOnProductChange, setPreserveLocationOnProductChange] = useState(false);
  const [isDraftHydrating, setIsDraftHydrating] = useState(true);
  const [isFloorProductsLoading, setIsFloorProductsLoading] = useState(false);
  const [isOnline, setIsOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
  const [offlineQueueCount, setOfflineQueueCount] = useState(0);
  const customerTypeInitRef = useRef(false);
  const previousCustomerTypeRef = useRef(customer_type);
  const floorProductsCacheRef = useRef({});
  const floorProductsEndpointAvailableRef = useRef(true);
  const productLocationCacheRef = useRef({});
  const productStockCacheRef = useRef({});
  const floorFilterRequestRef = useRef(0);
  const reconcileSaleStockCachesRef = useRef(null);

  // State End
  const [locations, setLocations] = useState(
    {
      prod_floor_name: "",
      prod_rack_name: "",
    } || []
  );
  const [floorData, setFloorData] = useState([]);

  const getProductLocationCacheKey = (productId) => `sales_product_locations_${productId}`;
  const getProductStockCacheKey = (productId) => `sales_product_stock_${productId}`;

  const loadProductLocationsFromCache = async (productId) => {
    if (!productId) return [];
    if (Array.isArray(productLocationCacheRef.current[productId])) {
      return productLocationCacheRef.current[productId];
    }

    const cachedRows = await getOfflineValue(getProductLocationCacheKey(productId), []);
    productLocationCacheRef.current[productId] = Array.isArray(cachedRows) ? cachedRows : [];
    return productLocationCacheRef.current[productId];
  };

  const saveProductLocationsToCache = async (productId, rows) => {
    if (!productId) return [];
    const nextRows = Array.isArray(rows) ? rows : [];
    productLocationCacheRef.current[productId] = nextRows;
    await setOfflineValue(getProductLocationCacheKey(productId), nextRows);
    return nextRows;
  };

  const loadProductStockFromCache = async (productId) => {
    if (!productId) return 0;
    if (productStockCacheRef.current[productId] != null) {
      return productStockCacheRef.current[productId];
    }

    const cachedStock = await getOfflineValue(getProductStockCacheKey(productId), null);
    if (cachedStock != null && cachedStock !== "") {
      const parsed = Number(cachedStock);
      productStockCacheRef.current[productId] = Number.isFinite(parsed) ? parsed : 0;
      return productStockCacheRef.current[productId];
    }

    const rows = await loadProductLocationsFromCache(productId);
    const totalQty = rows.reduce((sum, row) => sum + Number(row?.prod_qty || 0), 0);
    productStockCacheRef.current[productId] = totalQty;
    return totalQty;
  };

  const saveProductStockToCache = async (productId, stockValue) => {
    if (!productId) return 0;
    const parsed = Number(stockValue || 0);
    const nextStock = Number.isFinite(parsed) ? parsed : 0;
    productStockCacheRef.current[productId] = nextStock;
    await setOfflineValue(getProductStockCacheKey(productId), nextStock);
    return nextStock;
  };

  const updateProductLocationStockCache = async (saleItem = {}, qtyDelta = 0) => {
    const delta = Number(qtyDelta || 0);
    const productId = getSaleProductId(saleItem);
    if (!productId || delta === 0) return;

    let rows = await loadProductLocationsFromCache(productId);
    rows = Array.isArray(rows) ? rows.map((row) => ({ ...row })) : [];
    if (rows.length === 0) return;

    const targetFloorId = getSaleProductFloorId(saleItem);
    const targetRackId = getSaleProductRackId(saleItem);
    const targetRate = getSaleProductPurchaseRate(saleItem);
    const targetBatchId = getSaleProductStorageBatchId(saleItem);
    const rateKey = Number.isFinite(targetRate) ? targetRate.toFixed(4) : "0.0000";

    const nextRows = rows.map((row) => {
      const rowFloorId = Number(row?.prod_floor_id || 0);
      const rowRackId = Number(row?.prod_rack_id || 0);
      const rowRate = Number(row?.prod_purchase_rate || row?.average_purchase_rate || 0);
      const rowBatchId = Number(row?.storage_batch_id || 0);
      const rowMatches =
        (targetBatchId > 0 && rowBatchId === targetBatchId) ||
        (rowFloorId === targetFloorId &&
          rowRackId === targetRackId &&
          Number.isFinite(rowRate) &&
          rowRate.toFixed(4) === rateKey);

      if (!rowMatches) return row;

      const nextQty = Math.max(0, num(row?.prod_qty || 0) + delta);
      return {
        ...row,
        prod_qty: nextQty,
        current_quantity: nextQty,
        current_stock: nextQty,
      };
    });

    await saveProductLocationsToCache(productId, nextRows);
    await saveProductStockToCache(
      productId,
      nextRows.reduce((sum, row) => sum + num(row?.prod_qty || 0), 0)
    );
  };

  const emitSalesStockUpdate = (productIds = []) => {
    if (typeof window === "undefined") return;
    window.dispatchEvent(
      new CustomEvent("sales-stock-updated", {
        detail: {
          productIds: Array.isArray(productIds) ? productIds.filter(Boolean) : [],
          at: Date.now(),
        },
      })
    );
  };

  const getSaleProductId = (item) => Number(item?.prod_id || item?.sale_prod_id || 0);
  const getSaleProductQty = (item) => Number(item?.prod_qty || item?.sale_qty || 0);
  const getSaleProductFloorId = (item) => Number(item?.prod_floor || item?.prod_floor_id || 0);
  const getSaleProductRackId = (item) => Number(item?.prod_rack || item?.prod_rack_id || 0);
  const getSaleProductPurchaseRate = (item) =>
    Number(item?.prod_purchase_rate ?? item?.sale_prod_purchase_rate ?? 0);
  const getSaleProductSaleRate = (item) =>
    Number(item?.prod_sale_rate ?? item?.sale_rate ?? item?.prod_rate ?? 0);
  const getSaleProductStorageBatchId = (item) =>
    Number(item?.storage_batch_id ?? item?.prod_storage_batch_id ?? item?.sale_storage_batch_id ?? 0);
  const getSaleCartMergeKey = (item) =>
    [
      getSaleProductId(item),
      getSaleProductFloorId(item),
      getSaleProductRackId(item),
      getSaleProductSaleRate(item).toFixed(4),
    ].join("||");

  const findExactLocationRow = (rows, { floorId = 0, rackId = 0, purchaseRate = 0, storageBatchId = 0 } = {}) => {
    const list = Array.isArray(rows) ? rows : [];
    const normalizedFloorId = Number(floorId || 0);
    const normalizedRackId = Number(rackId || 0);
    const normalizedRate = Number(purchaseRate || 0);
    const normalizedBatchId = Number(storageBatchId || 0);
    const rateKey = Number.isFinite(normalizedRate) ? normalizedRate.toFixed(4) : "0.0000";

    return (
      list.find((row) => normalizedBatchId > 0 && Number(row?.storage_batch_id || 0) === normalizedBatchId) ||
      list.find((row) => {
        const rowFloorId = Number(row?.prod_floor_id || 0);
        const rowRackId = Number(row?.prod_rack_id || 0);
        const rowRate = Number(row?.prod_purchase_rate || 0);
        return (
          rowFloorId === normalizedFloorId &&
          rowRackId === normalizedRackId &&
          Number.isFinite(rowRate) &&
          rowRate.toFixed(4) === rateKey
        );
      }) ||
      list.find((row) => {
        const rowFloorId = Number(row?.prod_floor_id || 0);
        const rowRackId = Number(row?.prod_rack_id || 0);
        return rowFloorId === normalizedFloorId && rowRackId === normalizedRackId;
      }) ||
      list[0] ||
      null
    );
  };

  const reconcileSoldRows = (rows, saleItem) => {
    const productId = getSaleProductId(saleItem);
    const soldQty = getSaleProductQty(saleItem);
    if (!productId || soldQty <= 0) return Array.isArray(rows) ? rows : [];

    const floorId = getSaleProductFloorId(saleItem);
    const rackId = getSaleProductRackId(saleItem);
    const purchaseRate = getSaleProductPurchaseRate(saleItem);
    const floorName = normalizeText(saleItem?.prod_floor_name);
    const rackName = normalizeText(saleItem?.prod_rack_name);
    const saleKey = getSaleCartMergeKey(saleItem);
    const fallbackStock = Number(
      saleItem?.prod_stock_qty ??
      saleItem?.current_stock ??
      saleItem?.stock_qty ??
      0
    );

    const nextRows = Array.isArray(rows) ? rows.map((row) => ({ ...row })) : [];
    let matchedIndex = -1;

    for (let index = 0; index < nextRows.length; index += 1) {
      const row = nextRows[index];
      if (getSaleCartMergeKey(row) === saleKey) {
        matchedIndex = index;
        break;
      }
    }

    if (matchedIndex === -1) {
      matchedIndex = nextRows.findIndex((row) => {
        if (Number(row?.prod_id || 0) !== productId) return false;
        const rowFloorId = Number(row?.prod_floor_id || 0);
        const rowRackId = Number(row?.prod_rack_id || 0);
        const rowPurchaseRate = Number(row?.prod_purchase_rate || 0);
        const floorMatches = floorId ? rowFloorId === floorId : (!floorName || normalizeText(row?.prod_floor_name) === floorName);
        const rackMatches = rackId ? rowRackId === rackId : (!rackName || normalizeText(row?.prod_rack_name) === rackName);
        const rateMatches = Number(rowPurchaseRate.toFixed(4)) === Number(purchaseRate.toFixed(4));
        return floorMatches && rackMatches && rateMatches;
      });
    }

    if (matchedIndex > -1) {
      const currentQty = Number(nextRows[matchedIndex]?.prod_qty || 0);
      nextRows[matchedIndex] = {
        ...nextRows[matchedIndex],
        prod_qty: Math.max(0, currentQty - soldQty),
      };
      return nextRows;
    }

    nextRows.push({
      prod_id: productId,
      prod_name: saleItem?.prod_name || "",
      prod_code: saleItem?.prod_code || "",
      prod_floor_id: floorId,
      prod_floor_name: saleItem?.prod_floor_name || "",
      prod_rack_id: rackId,
      prod_rack_name: saleItem?.prod_rack_name || "",
      prod_qty: Math.max(0, fallbackStock - soldQty),
      prod_unit_name: saleItem?.prod_unit_name || "",
      prod_purchase_rate: purchaseRate || 0,
      average_purchase_rate: saleItem?.average_purchase_rate || saleItem?.prod_avarage_rate || 0,
      last_sale_rate: saleItem?.last_sale_rate || 0,
      last_sale_date: saleItem?.last_sale_date || "",
    });

    return nextRows;
  };

  const replaceProductRowsInGlobalCache = (globalRows, productId, nextRows) => {
    const sourceRows = Array.isArray(globalRows) ? globalRows : [];
    const remainingRows = sourceRows.filter((row) => Number(row?.prod_id || 0) !== Number(productId || 0));
    return [...remainingRows, ...(Array.isArray(nextRows) ? nextRows : [])];
  };

  const reconcileSaleStockCaches = async (saleCart = [], { refreshFromServer = false } = {}) => {
    const cartItems = Array.isArray(saleCart) ? saleCart : [];
    const groupedItems = new Map();

    cartItems.forEach((item) => {
      const productId = getSaleProductId(item);
      const soldQty = getSaleProductQty(item);
      if (!productId || soldQty <= 0) return;
      const existing = groupedItems.get(productId) || [];
      existing.push(item);
      groupedItems.set(productId, existing);
    });

    if (groupedItems.size === 0) return;

    let globalRows = await getOfflineValue(STORAGE_KEYS.salesProductLocations, []);
    if (!Array.isArray(globalRows)) {
      globalRows = [];
    }

    for (const [productId, items] of groupedItems.entries()) {
      let nextRows = [];
      let fetchedFreshRows = false;

      if (refreshFromServer && isOnline && authInfo?.token) {
        try {
          const response = await axios.post(
            `${API_URL}/api/get-product-location`,
            { productId },
            { headers: { "auth-token": authInfo.token } }
          );
          nextRows = Array.isArray(response?.data?.data) ? response.data.data : [];
          fetchedFreshRows = true;
        } catch (error) {
          console.error("Failed to refresh product stock cache:", error);
        }
      }

      if (!fetchedFreshRows) {
        const cachedRows = await loadProductLocationsFromCache(productId);
        nextRows = Array.isArray(cachedRows) ? cachedRows.map((row) => ({ ...row })) : [];
        for (const item of items) {
          nextRows = reconcileSoldRows(nextRows, item);
        }
      }

      await saveProductLocationsToCache(productId, nextRows);
      await saveProductStockToCache(
        productId,
        nextRows.reduce((sum, row) => sum + Number(row?.prod_qty || 0), 0)
      );
      globalRows = replaceProductRowsInGlobalCache(globalRows, productId, nextRows);
    }

    await setOfflineValue(STORAGE_KEYS.salesProductLocations, globalRows);
    emitSalesStockUpdate(Array.from(groupedItems.keys()));
  };

  useEffect(() => {
    reconcileSaleStockCachesRef.current = reconcileSaleStockCaches;
  }, [reconcileSaleStockCaches]);

  // Persist cart to localStorage whenever it changes
  useEffect(() => {
    const payloadCart = Array.isArray(cart) ? cart : [];
    const payloadStorageCart = Array.isArray(storageCart) ? storageCart : [];
    if (typeof window !== "undefined") {
      localStorage.setItem(SALES_CART_KEY, JSON.stringify(payloadCart));
      localStorage.setItem(SALES_STORAGE_CART_KEY, JSON.stringify(payloadStorageCart));
    }
    setOfflineValue(SALES_CART_KEY, payloadCart);
    setOfflineValue(SALES_STORAGE_CART_KEY, payloadStorageCart);
  }, [cart, storageCart]);

  // Persist current draft form so refresh doesn't clear current working data.
  useEffect(() => {
    const draftPayload = {
      selectedDate,
      customer_type,
      selectedEmployee,
      selectedCustomer,
      selectedContactPerson,
      po_id,
      note,
      discount,
      discount_percent,
      vat,
      vat_percent,
      ait,
      ait_percent,
      transport_cost,
      paid,
      previous_due,
      due,
      selectedCustomerPayMethod,
      selectedCustomerPayAcc,
      selectedProduct,
      selectedLocationRate,
      selectedFloor,
      selectedRack,
      product_purchase_rate,
      product_rate,
      product_brand,
      product_color,
      product_qty,
      product_total,
      enteredSetNo,
      editCartIndex,
    };
    if (typeof window !== "undefined") {
      localStorage.setItem(SALES_DRAFT_KEY, JSON.stringify(draftPayload));
    }
    setOfflineValue(SALES_DRAFT_KEY, draftPayload);
  }, [
    selectedDate,
    customer_type,
    selectedEmployee,
    selectedCustomer,
    selectedContactPerson,
    po_id,
    note,
    discount,
    discount_percent,
    vat,
    vat_percent,
    ait,
    ait_percent,
    transport_cost,
    paid,
    previous_due,
    due,
    selectedCustomerPayMethod,
    selectedCustomerPayAcc,
    selectedProduct,
    selectedLocationRate,
    selectedFloor,
    selectedRack,
    product_purchase_rate,
    product_rate,
    product_brand,
    product_color,
    product_qty,
    product_total,
    enteredSetNo,
    editCartIndex,
  ]);

  useEffect(() => {
    const customerTypeChanged = previousCustomerTypeRef.current !== customer_type;
    const shouldResetFields = customerTypeInitRef.current && customerTypeChanged && !isDraftHydrating && !hasSaleRouteId;
    if (shouldResetFields) {
      selectedProductSet(null);
      product_rate_set("");
      product_brand_set("");
      product_color_set("");
      product_qty_set("");
      product_purchase_rate_set(0);
    }
    if (customer_type == "retail") {
      getCustomers("retail");
    }
    if (customer_type == "wholesale") {
      getCustomers("wholesale");
    }

    if (!selectedFloor?.prod_floor_id) {
      productsSet(applyCustomerTypeRates(allProducts, customer_type));
    }
    customerTypeInitRef.current = true;
    previousCustomerTypeRef.current = customer_type;
  }, [customer_type, selectedFloor, allProducts]);

  useEffect(() => {
    const hydrateOfflineDraft = async () => {
      if (hasSaleRouteId) {
        setIsDraftHydrating(false);
        return;
      }

      const savedCart = await getOfflineValue(SALES_CART_KEY, null);
      if (Array.isArray(savedCart)) {
        cartSet(savedCart);
      } else if (typeof window !== "undefined") {
        const legacyCart = localStorage.getItem(SALES_CART_KEY);
        if (legacyCart) {
          try {
            const parsed = JSON.parse(legacyCart);
            if (Array.isArray(parsed)) cartSet(parsed);
          } catch (_error) {
            // ignore malformed legacy cart payload
          }
        }
      }

      const savedStorageCart = await getOfflineValue(SALES_STORAGE_CART_KEY, null);
      if (Array.isArray(savedStorageCart)) {
        storageCartSet(savedStorageCart);
      } else if (typeof window !== "undefined") {
        const legacyStorageCart = localStorage.getItem(SALES_STORAGE_CART_KEY);
        if (legacyStorageCart) {
          try {
            const parsed = JSON.parse(legacyStorageCart);
            if (Array.isArray(parsed)) storageCartSet(parsed);
          } catch (_error) {
            // ignore malformed legacy storage cart payload
          }
        }
      }

      const draft = await getOfflineValue(SALES_DRAFT_KEY, null);
      if (draft && typeof draft === "object") {
        if (draft.selectedDate) handleDateChangeSet(draft.selectedDate);
        if (draft.customer_type) customer_type_set(draft.customer_type);
        if (draft.selectedEmployee) selectedEmployeeSet(draft.selectedEmployee);
        if (draft.selectedCustomer) {
          selectedCustomerSet(draft.selectedCustomer);
          customer_name_set(draft.selectedCustomer.customer_name || "");
          customer_mobile_no_set(draft.selectedCustomer.customer_mobile_no || "");
          customer_address_set(draft.selectedCustomer.customer_address || "");
        }
        if (draft.selectedContactPerson) selectedContactPersonSet(draft.selectedContactPerson);
        if (draft.po_id != null) po_id_set(draft.po_id);
        if (draft.note != null) note_set(draft.note);
        discount_set(draft.discount || 0);
        discount_percent_set(draft.discount_percent || 0);
        vat_set(draft.vat || 0);
        vat_percent_set(draft.vat_percent || 0);
        ait_set(draft.ait || 0);
        ait_percent_set(draft.ait_percent || 0);
        transport_cost_set(draft.transport_cost || 0);
        paid_set(draft.paid || 0);
        previous_due_set(draft.previous_due || 0);
        due_set(draft.due || 0);
        if (draft.selectedCustomerPayMethod) selectedCustomerPayMethodSet(draft.selectedCustomerPayMethod);
        if (draft.selectedCustomerPayAcc) selectedCustomerPayAccSet(draft.selectedCustomerPayAcc);
        if (draft.selectedProduct) {
          setPreserveLocationOnProductChange(true);
          selectedProductSet(draft.selectedProduct);
        }
        if (draft.selectedLocationRate) setSelectedLocationRate(draft.selectedLocationRate);
        if (draft.selectedFloor) selectedFloorSet(draft.selectedFloor);
        if (draft.selectedRack) selectedRackSet(draft.selectedRack);
        if (draft.product_purchase_rate != null) product_purchase_rate_set(draft.product_purchase_rate);
        if (draft.product_rate != null) product_rate_set(draft.product_rate);
        if (draft.product_brand != null) product_brand_set(draft.product_brand);
        if (draft.product_color != null) product_color_set(draft.product_color);
        if (draft.product_qty != null) product_qty_set(draft.product_qty);
        if (draft.product_total != null) product_total_set(draft.product_total);
        if (draft.enteredSetNo != null) enteredSetNoSet(draft.enteredSetNo);
        if (draft.editCartIndex != null) editCartIndexSet(draft.editCartIndex);
      }
      setTimeout(() => setIsDraftHydrating(false), 0);
    };

    hydrateOfflineDraft();
  }, []);

  useEffect(() => {
    currentRouteSet(pathSpliter(location.pathname, 1));
    getInvoice();
    getEmployees();
    getFloors();
    getProducts();
    getTranAccs();

    if (hasSaleRouteId) {
      saleActionSet("update");
      saleIdSet(saleRouteSaleId);
      return;
    }

    // Check if redirect from Quotation or Invoice (via localStorage)
    let quote = null;
    let fromQuotation = false;

    // First check localStorage (from invoice return buttons)
    const storedData = localStorage.getItem('returnToSalesEntry');
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);
        quote = parsedData.quotationData;
        fromQuotation = parsedData.fromQuotation;
        // Clear localStorage after reading to prevent re-filling on refresh
        localStorage.removeItem('returnToSalesEntry');
      } catch (e) {
        console.error('Error parsing returnToSalesEntry from localStorage:', e);
      }
    }
    // Fallback to location.state if no localStorage data
    else if (location.state && location.state.quotationData && location.state.fromQuotation) {
      quote = location.state.quotationData;
      fromQuotation = location.state.fromQuotation;
    }

    if (quote && fromQuotation) {
      // Auto-fill Customer
      selectedCustomerSet({
        customer_name: quote.customer_name,
        display_text: quote.customer_name,
        customer_id: quote.customer_id,
      });
      customer_name_set(quote.customer_name);
      customer_mobile_no_set(quote.customer_mobile_no);
      customer_address_set(quote.customer_address);

      // Auto-fill Employee
      selectedEmployeeSet({
        employee_id: quote.sale_emp_id || quote.employee_id, // Adjust based on data
        employee_name: quote.employee_name,
      });

      // Auto-fill Cart (Products)
      if (quote.details && Array.isArray(quote.details)) {
        let newCart = quote.details.map((ele) => mapSaleDetailToCartItem(ele));

        // Ensure state update happens after mount safely
        setTimeout(() => {
          cartSet(newCart);
        }, 100);
      }

      // Auto-fill Financials
      // Note: sub_total is derived from cart via useEffect
      // But we can set initial values for others
      discount_set(quote.sale_discount_amount || 0);
      discount_percent_set(quote.sale_discount_percent || 0);
      vat_set(quote.sale_vat_amount || 0);
      vat_percent_set(quote.sale_vat_percent || 0);
      ait_set(quote.sale_ait_amount || 0);
      ait_percent_set(quote.sale_ait_percent || 0);
      transport_cost_set(quote.sale_transport_cost || 0);

      // Don't set sale_invoice, sale_created_isodt as we want new ones for the sale
    } else {
      // Restore draft if this is a fresh/new sales entry page.
      const draftRaw = localStorage.getItem(SALES_DRAFT_KEY);
      if (draftRaw) {
        try {
          const draft = JSON.parse(draftRaw);
          if (draft.selectedDate) handleDateChangeSet(draft.selectedDate);
          if (draft.customer_type) customer_type_set(draft.customer_type);
          if (draft.selectedEmployee) selectedEmployeeSet(draft.selectedEmployee);
          if (draft.selectedCustomer) {
            selectedCustomerSet(draft.selectedCustomer);
            customer_name_set(draft.selectedCustomer.customer_name || "");
            customer_mobile_no_set(draft.selectedCustomer.customer_mobile_no || "");
            customer_address_set(draft.selectedCustomer.customer_address || "");
          }
          if (draft.selectedContactPerson) selectedContactPersonSet(draft.selectedContactPerson);
          if (draft.po_id != null) po_id_set(draft.po_id);
          if (draft.note != null) note_set(draft.note);
          discount_set(draft.discount || 0);
          discount_percent_set(draft.discount_percent || 0);
          vat_set(draft.vat || 0);
          vat_percent_set(draft.vat_percent || 0);
          ait_set(draft.ait || 0);
          ait_percent_set(draft.ait_percent || 0);
          transport_cost_set(draft.transport_cost || 0);
          paid_set(draft.paid || 0);
          previous_due_set(draft.previous_due || 0);
          due_set(draft.due || 0);
           if (draft.selectedCustomerPayMethod) selectedCustomerPayMethodSet(draft.selectedCustomerPayMethod);
           if (draft.selectedCustomerPayAcc) selectedCustomerPayAccSet(draft.selectedCustomerPayAcc);

           if (draft.selectedProduct) {
             setPreserveLocationOnProductChange(true);
             selectedProductSet(draft.selectedProduct);
           }
           if (draft.selectedLocationRate) setSelectedLocationRate(draft.selectedLocationRate);
           if (draft.selectedFloor) selectedFloorSet(draft.selectedFloor);
           if (draft.selectedRack) selectedRackSet(draft.selectedRack);
           if (draft.product_purchase_rate != null) product_purchase_rate_set(draft.product_purchase_rate);
           if (draft.product_rate != null) product_rate_set(draft.product_rate);
           if (draft.product_brand != null) product_brand_set(draft.product_brand);
           if (draft.product_color != null) product_color_set(draft.product_color);
          if (draft.product_qty != null) product_qty_set(draft.product_qty);
          if (draft.product_total != null) product_total_set(draft.product_total);
          if (draft.enteredSetNo != null) enteredSetNoSet(draft.enteredSetNo);
          if (draft.editCartIndex != null) editCartIndexSet(draft.editCartIndex);
        } catch (_e) {
          // ignore bad draft payload
        }
      }
    }
    setTimeout(() => setIsDraftHydrating(false), 0);
  }, []);

  useEffect(() => {
    if (!hasSaleRouteId || !authInfo?.token) return;
    getSales(saleRouteSaleId);
  }, [hasSaleRouteId, saleRouteSaleId, authInfo?.token]);

  useEffect(() => {
    const syncOnlineState = async () => {
      setIsOnline(typeof navigator !== "undefined" ? navigator.onLine : true);
      setOfflineQueueCount(await getOfflineQueueCount());
    };

    window.addEventListener("online", syncOnlineState);
    window.addEventListener("offline", syncOnlineState);
    syncOnlineState();

    return () => {
      window.removeEventListener("online", syncOnlineState);
      window.removeEventListener("offline", syncOnlineState);
    };
  }, []);

  useEffect(() => {
    if (!isOnline || !authInfo?.token) return;

    syncOfflineSalesQueue(authInfo, {
      onItemSynced: async (item) => {
        if (typeof reconcileSaleStockCachesRef.current === "function") {
          await reconcileSaleStockCachesRef.current(item?.cart || [], { refreshFromServer: true });
        }
      },
    }).catch((error) => {
      console.error("Offline sale sync failed:", error);
    });
  }, [isOnline, authInfo]);

  useEffect(() => {
    const handleOfflineSalesSync = async (event) => {
      const detail = event?.detail || {};
      const queued = Number(detail?.queued || 0);
      const synced = Number(detail?.synced || 0);
      const status = String(detail?.status || "");

      setOfflineQueueCount(Number.isFinite(queued) ? queued : await getOfflineQueueCount());

      if (status === "completed" && synced > 0) {
        swal({
          title: "Offline sales synced",
          text: `${synced} sale(s) synced to the server successfully.`,
          icon: "success",
          timer: 2200,
          buttons: false,
        });
      }
    };

    window.addEventListener(OFFLINE_SALES_SYNC_EVENT, handleOfflineSalesSync);
    return () => {
      window.removeEventListener(OFFLINE_SALES_SYNC_EVENT, handleOfflineSalesSync);
    };
  }, []);

  const getTranAccs = async () => {
    try {
      const res = await axios.post(
        `${API_URL}/api/get-bank-accounts`,
        { "select-type": "active" },
        { headers: { "auth-token": authInfo.token } }
      );
      const nextValue = Array.isArray(res?.data?.message) ? res.data.message : [];
      customerPayAccsSet(nextValue);
      await cacheSalesMasterData("bank-accounts", nextValue);
    } catch (_error) {
      customerPayAccsSet(await loadSalesMasterData("bank-accounts", []));
    }
  };

  let getSales = async (targetSaleId = saleRouteSaleId) => {
    const saleIdToLoad = Number(targetSaleId);
    if (!Number.isFinite(saleIdToLoad)) return;
    try {
      const res = await axios.post(
        `${API_URL}/api/get-sales-with-details`,
        {
          reqPayload: { saleId: saleIdToLoad },
        },
        { headers: { "auth-token": authInfo.token } }
      );
        let sale = res.data.message[0];
        let cart = res.data.message[0].details;

        try {
          const dueRes = await axios.post(
            `${API_URL}/api/get-customer-due`,
            { customerId: sale.customer_id },
            { headers: { "auth-token": authInfo.token } }
          );
          if (Array.isArray(dueRes?.data) && dueRes.data.length > 0) {
            previous_due_set(Number(dueRes.data[0]?.dueAmount || 0));
          } else {
            previous_due_set(0);
          }
        } catch (_error) {
          previous_due_set(0);
        }

        sale_invoice_set(sale.sale_invoice);
        po_id_set(sale.sale_po_id)
        selectedEmployeeSet({
          employee_id: sale.sale_emp_id,
          employee_name: sale.employee_name,
        });
        handleDateChangeSet(sale.sale_created_isodt);
        selectedCustomerSet({
          customer_name: sale.customer_name,
          display_text: sale.customer_name,
          customer_id: sale.customer_id,
        });
        customer_name_set(sale.customer_name);
        customer_mobile_no_set(sale.customer_mobile_no);
        customer_address_set(sale.customer_address);
        customer_credit_limit_set(sale.customer_credit_limit);

        discount_set(sale.sale_discount_amount);
        discount_percent_set(sale.sale_discount_percent);
        vat_set(sale.sale_vat_amount);
        vat_percent_set(sale.sale_vat_percent);
        ait_set(sale.sale_ait_amount);
        ait_percent_set(sale.sale_ait_percent);
        total_amount_set(sale.sale_total_amount);
        paid_set(sale.sale_paid_amount);
        due_set(sale.sale_due_amount);
        transport_cost_set(sale.sale_transport_cost || 0);
        note_set(sale.sale_note || "");

        let newCart = cart.map((ele) => mapSaleDetailToCartItem(ele));
        cartSet(newCart);

        selectedCustomerPayMethodSet({
          pay_method_id: sale.sale_pay_method,
          pay_method: sale.sale_pay_method,
        });
        selectedCustomerPayAccSet({
          bank_display_name: sale.bank_display_name,
          bank_acc_id: sale.sale_bank_id,
        });
    } catch (error) {
      console.error("Error loading sale:", error);
    }
  };

  // ---- derived totals (Copied logic from purchase_entry)
  useEffect(() => {
    const total = cart.reduce((prev, curr) => {
      return prev + num(curr.prod_total);
    }, 0);
    sub_total_set(round2(total));
  }, [cart]);

  useEffect(() => {
    // Grand Total = (Subtotal - Discount) + VAT + AIT + Transport
    const afterDiscount = num(sub_total) - num(discount);
    let totalBill =
      afterDiscount +
      num(vat) +
      num(ait) +
      num(transport_cost);

    total_amount_set(Number.isFinite(totalBill) ? round2(totalBill) : 0);
  }, [
    sub_total,
    vat,
    ait,
    transport_cost,
    discount,
  ]);

  useEffect(() => {
    if (general_customer) {
      paid_set(total_amount);
      due_set(0);
    } else {
      let dueAmount = num(total_amount) - num(paid);
      due_set(Number.isFinite(dueAmount) ? round2(dueAmount) : 0);
    }
  }, [paid, total_amount, general_customer]);


  // ---- AUTO SYNC VAT/AIT/DISCOUNT when subtotal or discount changes
  useEffect(() => {
    // Discount depends on Subtotal
    if (discountMode === "percent") {
      discount_set(
        round2((num(sub_total) * num(discount_percent)) / 100)
      );
    } else {
      discount_percent_set(
        sub_total
          ? round2((num(discount) * 100) / num(sub_total))
          : 0
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sub_total, discount_percent]);

  useEffect(() => {
    // VAT calculated on DISCOUNTED amount (Subtotal - Discount)
    const afterDiscount = num(sub_total) - num(discount);

    if (vatMode === "percent") {
      vat_set(round2((afterDiscount * num(vat_percent)) / 100));
    } else {
      vat_percent_set(
        afterDiscount ? round2((num(vat) * 100) / afterDiscount) : 0
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sub_total, discount, vat_percent, vatMode]);

  useEffect(() => {
    // AIT calculated on DISCOUNTED amount (Subtotal - Discount)
    const afterDiscount = num(sub_total) - num(discount);

    if (aitMode === "percent") {
      ait_set(round2((afterDiscount * num(ait_percent)) / 100));
    } else {
      ait_percent_set(afterDiscount ? round2((num(ait) * 100) / afterDiscount) : 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sub_total, discount, ait_percent, aitMode]);

  // Handler helpers
  let handleDiscountInput = (e) => {
    const { name, value } = e.target;
    const normalizedValue = normalizeDecimalInput(value);

    if (name === "discount") {
      setDiscountMode("amount");
      const val = num(normalizedValue);
      discount_set(normalizedValue);
      const pct = sub_total ? round2((val * 100) / num(sub_total)) : 0;
      discount_percent_set(pct);
    } else {
      setDiscountMode("percent");
      const pct = num(normalizedValue);
      discount_percent_set(normalizedValue);
      const amo = round2((num(sub_total) * pct) / 100);
      discount_set(amo);
    }
  };

  let handleVatInput = (e) => {
    const { name, value } = e.target;
    const normalizedValue = normalizeDecimalInput(value);
    const afterDiscount = num(sub_total) - num(discount);

    if (name === "vat") {
      setVatMode("amount");
      const amo = num(normalizedValue);
      vat_set(normalizedValue);
      const pct = afterDiscount ? round2((amo * 100) / afterDiscount) : 0;
      vat_percent_set(pct);
    } else {
      setVatMode("percent");
      const pct = num(normalizedValue);
      vat_percent_set(normalizedValue);
      const amo = round2((afterDiscount * pct) / 100);
      vat_set(amo);
    }
  };

  let handleAitInput = (e) => {
    const { name, value } = e.target;
    const normalizedValue = normalizeDecimalInput(value);
    const afterDiscount = num(sub_total) - num(discount);

    if (name === "ait") {
      setAitMode("amount");
      const amo = num(normalizedValue);
      ait_set(normalizedValue);
      const pct = afterDiscount ? round2((amo * 100) / afterDiscount) : 0;
      ait_percent_set(pct);
    } else {
      setAitMode("percent");
      const pct = num(normalizedValue);
      ait_percent_set(normalizedValue);
      const amo = round2((afterDiscount * pct) / 100);
      ait_set(amo);
    }
  };

  let employeeRef = useRef(null);
  let poRef = useRef(null);
  let customerNameRef = useRef(null);
  let customerMobileRef = useRef(null);
  let customerAddressRef = useRef(null);
  let dateRef = useRef(null);
  let customerRef = useRef(null);
  let contactPersonRef = useRef(null);
  let productRef = useRef(null);
  let rateRef = useRef(null);
  let purchaseRateRef = useRef(null);
  let brandRef = useRef(null);
  let countryRef = useRef(null);
  let floorRef = useRef(null);
  let rackRef = useRef(null);
  let qtyRef = useRef(null);
  let addToCartRef = useRef(null);
  let vatRef = useRef(null);
  let vatPercentRef = useRef(null);
  let aitRef = useRef(null);
  let aitPercentRef = useRef(null);
  let discountRef = useRef(null);
  let discountPercentRef = useRef(null);
  let paidRef = useRef(null);
  let dueRef = useRef(null);
  let transportRef = useRef(null);
  let saleRef = useRef(null);
  let savingRef = useRef(false);
  let enteredSetNoRef = useRef(null);

  const focusRef = (ref) => {
    setTimeout(() => ref.current?.focus?.(), 0);
  };

  const focusAmountDetails = () => {
    focusRef(vatPercentRef);
  };

  const handleProductEnter = (e) => {
    if (e.key !== "Enter") return;

    const typedProduct = String(e.target.value || "").trim();
    if (!selectedProduct && typedProduct === "") {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    focusRef(brandRef);
  };

  const getFloors = async () => {
    if (!isOnline) {
      floorsSet(await loadSalesMasterData("floors", []));
      return;
    }
    try {
      const response = await axios.post(
        `${API_URL}/api/get-floors`,
        null,
        { headers: { "auth-token": authInfo.token } }
      );

      const nextValue = response?.data?.message || [];
      floorsSet(nextValue);
      await cacheSalesMasterData("floors", nextValue);
    } catch (error) {
      console.error("Error fetching floors:", error);
      floorsSet(await loadSalesMasterData("floors", []));
    }
  };

  const filterProductsByFloor = async (floorItem, sourceProducts = allProducts) => {
    if (!floorItem?.prod_floor_id) {
      productsSet(applyCustomerTypeRates(sourceProducts || [], customer_type));
      return;
    }

    const requestId = ++floorFilterRequestRef.current;
    productsSet([]);
    setIsFloorProductsLoading(true);
    try {
      const floorId = normalizeFloorId(floorItem.prod_floor_id);
      const selectedFloorName = normalizeText(floorItem?.prod_floor_name);
      const cachedSourceProducts = Array.isArray(sourceProducts) ? sourceProducts : [];
      const offlineFallbackProducts = cachedSourceProducts.filter((prod) => {
        const prodFloorId = normalizeFloorId(prod?.prod_floor_id ?? prod?.sale_prod_floor);
        const prodFloorName = normalizeText(prod?.prod_floor_name);
        return (
          prodFloorId === floorId ||
          (selectedFloorName && prodFloorName === selectedFloorName)
        );
      });

      const cachedGlobalLocationRows = await loadSalesMasterData("product-locations", []);
      const locationBasedProducts = (Array.isArray(cachedGlobalLocationRows) ? cachedGlobalLocationRows : [])
        .filter((row) => {
          const rowFloorId = normalizeFloorId(row?.prod_floor_id);
          const rowFloorName = normalizeText(row?.prod_floor_name);
          return rowFloorId === floorId || (selectedFloorName && rowFloorName === selectedFloorName);
        })
        .map((row) => Number(row?.prod_id || row?.sale_prod_id || 0))
        .filter(Boolean);
      const locationBasedProductIdSet = new Set(locationBasedProducts);
      const locationBasedProductsList = locationBasedProductIdSet.size
        ? cachedSourceProducts.filter((prod) => locationBasedProductIdSet.has(Number(prod?.prod_id || 0)))
        : [];

      const getProductLocations = async (productId) => {
        if (!productId) return [];
        if (!isOnline) {
          return await loadProductLocationsFromCache(productId);
        }
        if (!(productId in productLocationCacheRef.current)) {
          try {
            const response = await axios.post(
              `${API_URL}/api/get-product-location`,
              { productId },
              { headers: { "auth-token": authInfo.token } }
            );
            await saveProductLocationsToCache(
              productId,
              Array.isArray(response?.data?.data) ? response.data.data : []
            );
          } catch (error) {
            console.error("Error fetching product locations for floor filter:", error);
            await saveProductLocationsToCache(productId, []);
          }
        }

        return productLocationCacheRef.current[productId];
      };

      let matchedProducts = floorProductsCacheRef.current[floorId];
      if (!Array.isArray(matchedProducts)) {
        if (!isOnline) {
          matchedProducts = offlineFallbackProducts.length > 0
            ? offlineFallbackProducts
            : cachedSourceProducts;
          floorProductsCacheRef.current[floorId] = matchedProducts;
          if (requestId === floorFilterRequestRef.current) {
            productsSet(applyCustomerTypeRates(matchedProducts, customer_type));
          }
          return;
        }

        if (floorProductsEndpointAvailableRef.current) {
          try {
            const response = await axios.post(
              `${API_URL}/api/get-floor-products`,
              { floorId },
              { headers: { "auth-token": authInfo.token } }
            );
            matchedProducts = Array.isArray(response?.data?.message) ? response.data.message : [];
          } catch (error) {
            if (error?.response?.status === 404) {
              floorProductsEndpointAvailableRef.current = false;
            } else {
              throw error;
            }
          }
        }

        if (!Array.isArray(matchedProducts)) {
          const strictMatches = await Promise.all(
            (sourceProducts || []).map(async (prod) => {
              const productId = Number(prod?.prod_id || 0);
              if (!productId) return null;

              const locations = await getProductLocations(productId);
              const hasFloorMatch = locations.some((row) => {
                const rowFloorId = normalizeFloorId(row?.prod_floor_id);
                const rowFloorName = normalizeText(row?.prod_floor_name);
                const rowRackName = normalizeText(row?.prod_rack_name);
                return (
                  rowRackName !== "" &&
                  (rowFloorId === floorId || (selectedFloorName && rowFloorName === selectedFloorName))
                );
              });

              return hasFloorMatch ? prod : null;
            })
          );
          matchedProducts = strictMatches.filter(Boolean);
        }

        if (!Array.isArray(matchedProducts) || matchedProducts.length === 0) {
          matchedProducts = locationBasedProductsList.length > 0
            ? locationBasedProductsList
            : offlineFallbackProducts;
        }

        floorProductsCacheRef.current[floorId] = matchedProducts;
      }

      if (requestId === floorFilterRequestRef.current) {
        productsSet(applyCustomerTypeRates(mergeUniqueProducts(matchedProducts, selectedProduct ? [selectedProduct] : []), customer_type));
      }
    } catch (error) {
      console.error("Error fetching floor products:", error);
      if (requestId === floorFilterRequestRef.current) {
        productsSet([]);
      }
    } finally {
      if (requestId === floorFilterRequestRef.current) {
        setIsFloorProductsLoading(false);
      }
    }
  };

  const fetchRacks = async () => {
      if (selectedProduct?.prod_id && selectedFloor?.prod_floor_id) {
        if (!isOnline) {
          const cachedRows = await loadProductLocationsFromCache(selectedProduct.prod_id);
          const selectedFloorId = Number(selectedFloor?.prod_floor_id || 0);
          const cachedRacks = cachedRows
          .filter((row) => Number(row?.prod_floor_id || 0) === selectedFloorId)
          .map((row) => ({
            prod_rack_id: row?.prod_rack_id,
            prod_rack_name: row?.prod_rack_name,
          }))
          .filter((row, idx, arr) => row.prod_rack_id && arr.findIndex((x) => x.prod_rack_id === row.prod_rack_id) === idx);

        if (cachedRacks.length > 0) {
          racksSet(cachedRacks);
          return;
        }

        const fallbackRack = selectedProduct?.prod_rack_id
          ? [{ prod_rack_id: selectedProduct.prod_rack_id, prod_rack_name: selectedProduct.prod_rack_name || "Cached rack" }]
          : [];
        racksSet(fallbackRack);
        return;
      }

      try {
        const response = await axios.post(
          `${API_URL}/api/get-product-location`,
          { productId: selectedProduct.prod_id },
          { headers: { "auth-token": authInfo.token } }
        );

        if (response.data && !response.data.error) {
          const rows = Array.isArray(response?.data?.data) ? response.data.data : [];
          await saveProductLocationsToCache(selectedProduct.prod_id, rows);
          const selectedFloorId = Number(selectedFloor?.prod_floor_id || 0);
          const hasStrictFloorMatch = rows.some((row) => {
            const rowFloorId = Number(row?.prod_floor_id || 0);
            const rowRackName = String(row?.prod_rack_name || "").trim();
            return rowFloorId === selectedFloorId && rowRackName !== "";
          });

          if (!hasStrictFloorMatch) {
            racksSet([]);
            return;
          }

          const rackResponse = await axios.post(
            `${API_URL}/api/get-product-racks`,
            {
              productId: selectedProduct.prod_id,
              floorId: selectedFloor.prod_floor_id,
            },
            { headers: { "auth-token": authInfo.token } }
          );

          if (rackResponse.data && !rackResponse.data.error) {
            racksSet(Array.isArray(rackResponse?.data?.data) ? rackResponse.data.data : []);
          } else {
            console.error("API returned an error:", rackResponse.data.message);
            racksSet([]);
          }
        } else {
          console.error("API returned an error:", response.data.message);
          racksSet([]);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
        racksSet([]);
      }
    } else {
      racksSet([]);
    }
  };

  const fetchProductQuantity = async () => {
      if (
        selectedProduct?.prod_id &&
        selectedFloor?.prod_floor_id &&
        selectedRack?.prod_rack_id
      ) {
      if (!isOnline) {
        const cachedRows = await loadProductLocationsFromCache(selectedProduct.prod_id);
        const selectedFloorId = Number(selectedFloor?.prod_floor_id || 0);
        const selectedRackId = Number(selectedRack?.prod_rack_id || 0);
        const matchedRow = findExactLocationRow(cachedRows, {
          floorId: selectedFloorId,
          rackId: selectedRackId,
          purchaseRate: selectedLocationRate?.prod_purchase_rate ?? product_purchase_rate ?? selectedProduct?.prod_purchase_rate ?? selectedProduct?.sale_prod_purchase_rate ?? 0,
          storageBatchId: selectedProduct?.storage_batch_id ?? selectedProduct?.prod_storage_batch_id ?? 0,
        });

        selectedQuantitySet(
          matchedRow?.prod_qty ??
          selectedProduct?.prod_qty ??
          0
        );
        return;
      }

      try {
        const response = await axios.post(
          `${API_URL}/api/get-product-quantity`,
          {
            productId: selectedProduct.prod_id,
            floorId: selectedFloor.prod_floor_id,
            rackId: selectedRack.prod_rack_id,
            purchaseRate: selectedLocationRate?.prod_purchase_rate ?? product_purchase_rate ?? selectedProduct?.prod_purchase_rate ?? selectedProduct?.sale_prod_purchase_rate ?? 0,
            storageBatchId: selectedProduct?.storage_batch_id ?? selectedProduct?.prod_storage_batch_id ?? 0,
          },
          { headers: { "auth-token": authInfo.token } }
        );

        if (response.data && !response.data.error) {
          const nextQty = response.data.data[0].prod_qty;
          selectedQuantitySet(nextQty);
          await saveProductStockToCache(selectedProduct.prod_id, nextQty);
        } else {
          console.error("API returned an error:", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
        const cachedQty = await loadProductStockFromCache(selectedProduct.prod_id);
        selectedQuantitySet(cachedQty);
      }
    }
  };

  const applyLocationRateSelection = (row) => {
    if (!row) {
      setSelectedLocationRate(null);
      product_purchase_rate_set(0);
      selectedQuantitySet(null);
      return;
    }

    const nextRate = normalizePurchaseRate(row?.prod_purchase_rate ?? 0);
    setSelectedLocationRate(row);
    product_purchase_rate_set(nextRate);
    selectedQuantitySet(row?.prod_qty ?? null);
  };

  const fetchProductLocationRate = async () => {
    if (!selectedProduct?.prod_id) {
      product_purchase_rate_set(0);
      setLocationRateOptions([]);
      setSelectedLocationRate(null);
      return;
    }

    try {
      const selectedFloorId = Number(selectedFloor?.prod_floor_id || 0);
      const selectedRackId = Number(selectedRack?.prod_rack_id || 0);

      if (!isOnline) {
        const cachedRows = await loadProductLocationsFromCache(selectedProduct.prod_id);
        const options = groupLocationRateRows(cachedRows, selectedFloorId, selectedRackId);
        setLocationRateOptions(options);
        const preferredRate = normalizePurchaseRate(selectedLocationRate?.prod_purchase_rate ?? product_purchase_rate ?? selectedProduct?.prod_purchase_rate ?? selectedProduct?.sale_prod_purchase_rate ?? 0);
        const matchedRow =
          options.find((row) => normalizePurchaseRate(row?.prod_purchase_rate) === preferredRate) ||
          (options.length === 1 ? options[0] : null);
        applyLocationRateSelection(matchedRow);
        return;
      }

      let rows = productLocationCacheRef.current[selectedProduct.prod_id];
      if (!Array.isArray(rows)) {
        const response = await axios.post(
          `${API_URL}/api/get-product-location`,
          { productId: selectedProduct.prod_id },
          { headers: { "auth-token": authInfo.token } }
        );
        rows = Array.isArray(response?.data?.data) ? response.data.data : [];
        await saveProductLocationsToCache(selectedProduct.prod_id, rows);
      }
      const locationTotalStock = (Array.isArray(rows) ? rows : []).reduce(
        (sum, row) => sum + Number(row?.prod_qty || row?.current_stock || 0),
        0
      );
      if (locationTotalStock > 0) {
        product_total_stock_qty_set(locationTotalStock);
        product_stock_qty_set((prev) => {
          const previousStock = Number(prev);
          return Math.max(Number.isFinite(previousStock) ? previousStock : 0, locationTotalStock);
        });
      }

      const options = groupLocationRateRows(rows, selectedFloorId, selectedRackId);
      setLocationRateOptions(options);

      if (options.length === 0) {
        setSelectedLocationRate(null);
        product_purchase_rate_set(0);
        return;
      }

      const preferredRate = normalizePurchaseRate(selectedLocationRate?.prod_purchase_rate ?? product_purchase_rate ?? selectedProduct?.prod_purchase_rate ?? selectedProduct?.sale_prod_purchase_rate ?? 0);
      const matchedRow =
        options.find((row) => normalizePurchaseRate(row?.prod_purchase_rate) === preferredRate) ||
        (options.length === 1 ? options[0] : null);

      applyLocationRateSelection(matchedRow);
    } catch (error) {
      console.error("Error fetching product purchase rate:", error);
      setLocationRateOptions([]);
      setSelectedLocationRate(null);
      product_purchase_rate_set(0);
    }
  };

  useEffect(() => {
    product_total_set(product_rate * product_qty);
  }, [product_rate, product_qty]);

  useEffect(() => {
    if (selectedProduct && enteredSetNo > 0) {
      const setNo = parseInt(enteredSetNo);
      const setQty = parseInt(selectedProduct.prod_set_qty || 0);
      const totalPieces = setNo * setQty;
      product_qty_set(totalPieces.toString());
    }
  }, [enteredSetNo, selectedProduct]);

  useEffect(() => {
    if (selectedProduct != null) {
      if (!isOnline) {
        loadProductStockFromCache(selectedProduct.prod_id).then((cachedQty) => {
          const nextStock =
            cachedQty ??
            selectedProduct?.prod_qty ??
            selectedProduct?.current_stock ??
            selectedProduct?.stock_qty ??
            "0";
          product_stock_qty_set(nextStock);
          product_total_stock_qty_set(nextStock);
        });
        return;
      }
      axios
        .post(
          `${API_URL}/api/get-product-current-stock`,
          { product_id: selectedProduct.prod_id },
          { headers: { "auth-token": authInfo.token } }
        )
        .then((res) => {
          const nextStock = res.data.message;
          product_stock_qty_set(nextStock);
          product_total_stock_qty_set(nextStock);
          saveProductStockToCache(selectedProduct.prod_id, nextStock);
        })
        .catch(async (_error) => {
          const cachedQty = await loadProductStockFromCache(selectedProduct.prod_id);
          const nextStock =
            cachedQty ??
            selectedProduct?.prod_qty ??
            selectedProduct?.current_stock ??
            selectedProduct?.stock_qty ??
            "0";
          product_stock_qty_set(nextStock);
          product_total_stock_qty_set(nextStock);
        });
    } else {
      product_stock_qty_set("Stock Qty");
      product_total_stock_qty_set("Stock Qty");
      product_brand_set("");
      product_color_set("");
    }
  }, [selectedProduct]);

  let getInvoice = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/get-sales-invoice`, {
        headers: { "auth-token": authInfo.token },
      });
      sale_invoice_set(res.data.message);
    } catch (error) {
      console.error("Failed to load invoice number:", error);
      sale_invoice_set(`OFFLINE-${Date.now()}`);
    }
  };

  let getEmployees = async () => {
    if (!isOnline) {
      employeesSet(await loadSalesMasterData("employees", []));
      return;
    }
    try {
      const res = await axios.post(
        `${API_URL}/api/get-employees`,
        { "select-type": "active" },
        { headers: { "auth-token": authInfo.token } }
      );
      const nextValue = Array.isArray(res?.data?.message) ? res.data.message : [];
      employeesSet(nextValue);
      await cacheSalesMasterData("employees", nextValue);
    } catch (_error) {
      employeesSet(await loadSalesMasterData("employees", []));
    }
  };

  let getCustomers = async (type = "retail") => {
    const cacheKey = type === "wholesale" ? "customers-wholesale" : "customers-retail";
    if (!isOnline) {
      customersSet(await loadSalesMasterData(cacheKey, []));
      return;
    }
    try {
      const res = await axios.post(
        `${API_URL}/api/get-customers`,
        { "select-type": "active", "customer-type": type },
        { headers: { "auth-token": authInfo.token } }
      );
      const nextValue = (Array.isArray(res?.data?.message) ? res.data.message : []).map((customer) => ({
        ...customer,
        display_text:
          customer?.display_text ||
          customer?.customer_name ||
          customer?.customer_full_name ||
          "",
      }));
      nextValue.unshift({
        customer_id: 0,
        customer_name: "General customer",
        display_text: "General customer",
        customer_mobile_no: "",
        customer_address: "",
        customer_type: "general",
      });
      customersSet(nextValue);
      await cacheSalesMasterData(cacheKey, nextValue);
    } catch (_error) {
      customersSet(await loadSalesMasterData(cacheKey, []));
    }
  };

  let getContactPersons = async (id) => {
    if (!isOnline) {
      contactPersonsSet([]);
      return;
    }
    try {
      const response = await axios.post(
        `${API_URL}/api/get-contact-persons`,
        { customer_id: id },
        {
          headers: { "auth-token": authInfo.token },
        }
      );
      contactPersonsSet(response.data.message);
    } catch (error) {
      console.error("Error fetching contact persons:", error);
    }
  };

  useEffect(() => {
    if (selectedCustomer) {
      getContactPersons(selectedCustomer.customer_id);
    }
    selectedContactPersonSet(null)
  }, [selectedCustomer]);

  let getProducts = async () => {
    if (!isOnline) {
      const cachedProducts = await loadSalesMasterData("products", []);
      const nextProducts = applyCustomerTypeRates(cachedProducts);
      allProductsSet(nextProducts);
      if (selectedFloor?.prod_floor_id) {
        await filterProductsByFloor(selectedFloor, nextProducts);
      } else {
        productsSet(nextProducts);
      }
      return;
    }
    try {
      const res = await axios.post(
        `${API_URL}/api/get-individual-products`,
        {
          "select-type": "active",
          prodId: selectedProduct != null ? selectedProduct.prod_id : null,
          limit: 80,
        },
        { headers: { "auth-token": authInfo.token } }
      );
      const nextProducts = applyCustomerTypeRates(res.data.message || []);
      allProductsSet(nextProducts);
      if (selectedFloor?.prod_floor_id) {
        await filterProductsByFloor(selectedFloor, nextProducts);
      } else {
        productsSet(nextProducts);
      }
    } catch (_error) {
      const cachedProducts = await loadSalesMasterData("products", []);
      const nextProducts = applyCustomerTypeRates(cachedProducts);
      allProductsSet(nextProducts);
      if (selectedFloor?.prod_floor_id) {
        await filterProductsByFloor(selectedFloor, nextProducts);
      } else {
        productsSet(nextProducts);
      }
    }
  };

  const searchProductsForSale = async (queryText) => {
    const searchText = String(queryText || "").trim();
    if (!isOnline || !authInfo?.token || searchText.length < 2) return;

    setProductLookupLoading(true);
    try {
      const response = await axios.post(
        `${API_URL}/api/get-individual-products`,
        {
          searchText,
          limit: 50,
        },
        { headers: { "auth-token": authInfo.token } }
      );
      const nextProducts = applyCustomerTypeRates(response?.data?.message || []);
      const mergedProducts = mergeUniqueProducts(
        nextProducts,
        products,
        allProducts,
        selectedProduct ? [selectedProduct] : []
      );
      allProductsSet(mergedProducts);
      if (selectedFloor?.prod_floor_id) {
        productsSet(applyCustomerTypeRates(mergeUniqueProducts(nextProducts, products), customer_type));
      } else {
        productsSet(applyCustomerTypeRates(mergedProducts, customer_type));
      }
    } catch (error) {
      console.error("Product search failed:", error);
    } finally {
      setProductLookupLoading(false);
    }
  };

  let productToCart = async () => {
    if (selectedProduct == null) {
      swal({ title: "Select Product", icon: "warning" });
      return false;
    }
    if (selectedFloor == null) {
      swal({ title: "Select Floor", icon: "warning" });
      return false;
    }
    if (selectedRack == null) {
      swal({ title: "Select Rack", icon: "warning" });
      return false;
    }
    if (locationRateOptions.length > 1 && !selectedLocationRate) {
      swal({ title: "Choose Purchase Rate", icon: "warning" });
      return false;
    }
    if (parseFloat(product_rate) <= 0 || product_rate === "" || isNaN(parseFloat(product_rate))) {
      swal({ title: "Sale Rate is Invalid.", icon: "warning" });
      return false;
    }

    const existingEditItem = editCartIndex !== null ? cart[editCartIndex] : null;

    const cartItem = {
      prod_id: selectedProduct.prod_id,
      prod_name: selectedProduct.prod_name,
      prod_sale_rate: product_rate,
      prod_brand: product_brand,
      prod_color: product_color,
      prod_floor: selectedFloor?.prod_floor_id,
      prod_floor_name: floors.find(f => f.prod_floor_id === selectedFloor.prod_floor_id)?.prod_floor_name,
      prod_rack: selectedRack?.prod_rack_id,
      prod_rack_name: racks.find(f => f.prod_rack_id === selectedRack.prod_rack_id)?.prod_rack_name,
      prod_qty: product_qty,
      prod_purchase_rate: product_purchase_rate,
      storage_batch_id: selectedLocationRate?.storage_batch_id ?? 0,
      prod_total: product_total,
      prod_unit_name: selectedProduct.prod_unit_name || "",
      prod_set_no: selectedProduct.prod_set_no || "",
      prod_set_qty: selectedProduct.prod_set_qty || "",
      entered_set_no: enteredSetNo || "",
      prod_stock_qty: 0,
    };

    const sameEditKey =
      existingEditItem &&
      getSaleCartMergeKey(existingEditItem) === getSaleCartMergeKey(cartItem);

    const resolvedStockQty = Number.isFinite(Number(product_total_stock_qty)) && Number(product_total_stock_qty) > 0
      ? Number(product_total_stock_qty)
      : await loadProductStockFromCache(selectedProduct.prod_id);

    const fallbackStockQty = Number(
      selectedProduct?.prod_qty ??
      selectedProduct?.current_stock ??
      selectedProduct?.stock_qty ??
      0
    );

    const totalAvailableStock = Number.isFinite(resolvedStockQty) && resolvedStockQty > 0
      ? resolvedStockQty
      : fallbackStockQty;
    const editableAvailableStock = totalAvailableStock + (sameEditKey ? num(existingEditItem?.prod_qty || 0) : 0);
    const stockLimitForValidation = editCartIndex !== null ? editableAvailableStock : totalAvailableStock;

    // ✅ FIXED TOTAL STOCK VALIDATION (not per rack)
    if (stockLimitForValidation <= 0) {
      swal({ title: "Stock Unavailable", icon: "warning" });
      return false;
    }

    if (parseFloat(product_qty) > stockLimitForValidation) {
      swal({
        title: "Quantity exceeds total available stock.",
        icon: "warning"
      });
      return false;
    }

    if (parseFloat(product_qty) <= 0 || isNaN(parseFloat(product_qty))) {
      swal({ title: "Invalid Product Quantity", icon: "warning" });
      return false;
    }

    cartItem.prod_stock_qty = stockLimitForValidation;

    const storageProduct = {
      prod_id: selectedProduct?.prod_id,
      prod_qty: product_qty,
      prod_floor_id: selectedFloor?.prod_floor_id,
      prod_rack_id: selectedRack?.prod_rack_id,
      prod_purchase_rate: product_purchase_rate,
      storage_batch_id: selectedLocationRate?.storage_batch_id ?? 0,
    };

    const editOriginalQty = num(existingEditItem?.prod_qty || 0);
    if (editCartIndex !== null && existingEditItem) {
      await updateProductLocationStockCache(existingEditItem, editOriginalQty);
    }

    await updateProductLocationStockCache(cartItem, -num(product_qty));

    const nextCart = [...cart];
    const nextStorageCart = [...storageCart];

    if (editCartIndex !== null) {
      nextCart[editCartIndex] = cartItem;
      nextStorageCart[editCartIndex] = storageProduct;
    } else {
      nextCart.push(cartItem);
      nextStorageCart.push(storageProduct);
    }

    const sameKeyIndexes = nextCart
      .map((item, idx) => ({ item, idx }))
      .filter(({ item }) => getSaleCartMergeKey(item) === getSaleCartMergeKey(cartItem))
      .map(({ idx }) => idx);

    if (sameKeyIndexes.length > 1) {
      const primaryIndex = sameKeyIndexes[0];
      const mergedQty = sameKeyIndexes.reduce((sum, idx) => sum + num(nextCart[idx]?.prod_qty), 0);
      const mergedStorageQty = sameKeyIndexes.reduce((sum, idx) => sum + num(nextStorageCart[idx]?.prod_qty), 0);
      const baseCartItem = nextCart[primaryIndex];
      const baseStorageItem = nextStorageCart[primaryIndex];

      sameKeyIndexes
        .slice(1)
        .sort((a, b) => b - a)
        .forEach((idx) => {
          nextCart.splice(idx, 1);
          nextStorageCart.splice(idx, 1);
        });

      nextCart[primaryIndex] = {
        ...baseCartItem,
        prod_qty: mergedQty,
        prod_total: round2(num(baseCartItem?.prod_sale_rate) * mergedQty),
      };

      nextStorageCart[primaryIndex] = {
        ...baseStorageItem,
        prod_qty: mergedStorageQty,
      };
    }

    cartSet(nextCart);
    storageCartSet(nextStorageCart);

    // Reset item fields but keep the selected sale floor.
    product_rate_set(0);
    product_brand_set("");
    product_color_set("");
    product_purchase_rate_set(0);
    product_qty_set("");
    product_total_set(0);
    selectedRackSet(null);
    selectedProductSet(null);
    setProductSearchInput("");
    selectedQuantitySet(null);
    enteredSetNoSet("");
    editCartIndexSet(null);

    setResetKey(prev => prev + 1);

    focusRef(productRef);
  };


  let cartFromRemove = (index) => {
    let hardCopy = [...cart];
    hardCopy.splice(index, 1);
    cartSet(hardCopy);

    let storageCopy = [...storageCart];
    storageCopy.splice(index, 1);
    storageCartSet(storageCopy);
  };

  const cartToEdit = (index) => {
    const target = cart[index];
    if (!target) return;

    hydrateEditorFromCartItem(target);
    editCartIndexSet(index);
    focusRef(productRef);
  };

  const [purchaseRateShow, purchaseRateShowSet] = useState(true);

  let purchaseRateShowAction = () => {
    if (purchaseRateShow == true) {
      purchaseRateShowSet(false);
    } else {
      purchaseRateShowSet(true);
    }
  };

  const resetForm = () => {
    localStorage.removeItem(SALES_DRAFT_KEY);
    localStorage.removeItem(SALES_CART_KEY);
    localStorage.removeItem(SALES_STORAGE_CART_KEY);
    removeOfflineValue(SALES_DRAFT_KEY);
    removeOfflineValue(SALES_CART_KEY);
    removeOfflineValue(SALES_STORAGE_CART_KEY);
    cartSet([]);
    storageCartSet([]);
    selectedCustomerSet(null);
    customer_name_set("");
    customer_mobile_no_set("");
    customer_address_set("");
    selectedEmployeeSet(null);
    selectedContactPersonSet(null);
    selectedFloorSet(null);
    selectedRackSet(null);
    selectedProductSet(null);
    selectedQuantitySet(null);
    discount_set(0);
    discount_percent_set(0);
    vat_set(0);
    vat_percent_set(0);
    ait_set(0);
    ait_percent_set(0);
    transport_cost_set(0);
    paid_set(0);
    note_set("");
    po_id_set("");
    previous_due_set(0);
    due_set(0);
    total_amount_set(0);
    sub_total_set(0);
    handleDateChangeSet(currentDateTime);
    saveActionSet(false);
    saleActionSet("save");
    saleIdSet(null);
    editCartIndexSet(null);
    enteredSetNoSet("");

    // Clear route state for a clean slate
    if (history) history.replace("/sales/sales-entry");

    // Fetch fresh invoice no
    getInvoice();
  };

  let saleSaveAction = async () => {
    if (savingRef.current || saveAction) return false;
    savingRef.current = true;

    if (po_id == null || po_id.trim() === "") {
      savingRef.current = false;
      swal({ title: "Po is required.", icon: "warning" });
      return false;
    }
    if (selectedEmployee == null) {
      savingRef.current = false;
      swal({ title: "Employee is required.", icon: "warning" });
      return false;
    }
    if (selectedCustomer == null) {
      savingRef.current = false;
      swal({ title: "Customer is required.", icon: "warning" });
      return false;
    }
    if (cart.length === 0) {
      savingRef.current = false;
      swal({ title: "Cart is Empty.", icon: "warning" });
      return false;
    }

    if (paid > 0 && selectedCustomerPayMethod == null) {
      savingRef.current = false;
      swal({
        title: "Select Payment Receive Method",
        icon: "warning",
      });
      return false;
    }

    if (
      paid > 0 &&
      selectedCustomerPayMethod != null &&
      selectedCustomerPayMethod.pay_method_id === "bank" &&
      selectedCustomerPayAcc == null
    ) {
      savingRef.current = false;
      swal({
        title: "Select Payment Receive Account",
        icon: "warning",
      });
      return false;
    }

    const sale = {
      sale_invoice,
      sale_po_id: po_id,
      sale_emp_id: selectedEmployee != null ? selectedEmployee.employee_id : 0,
      created_isodt: selectedDate,
      customer_id: selectedCustomer.customer_id,
      contact_person_id: selectedContactPerson?.contact_person_id,
      customer_name: customer_name,
      customer_mobile_no: customer_mobile_no,
      customer_address: customer_address,
      sale_transport_cost: transport_cost,
      sub_total,
      previous_due,
      vat,
      vat_percent,
      ait,
      ait_percent,
      discount,
      discount_percent,
      total_amount,
      paid,
      due,
      sale_id: saleId,
      sale_cus_type:
        selectedCustomer.customer_type == undefined
          ? "general"
          : selectedCustomer.customer_type,
      sale_pay_method:
        selectedCustomerPayMethod != null
          ? selectedCustomerPayMethod.pay_method_id
          : "cash",
      sale_bank_id:
        selectedCustomerPayMethod == null ||
        selectedCustomerPayMethod.pay_method_id == "cash"
          ? 0
          : selectedCustomerPayAcc.bank_acc_id,
      note,
    };

    const endpoint = saleAction == "update" ? "/api/update-sale" : "/api/save-sale";
    const finalizeLocalSuccess = async () => {
      localStorage.removeItem(SALES_DRAFT_KEY);
      localStorage.removeItem(SALES_CART_KEY);
      localStorage.removeItem(SALES_STORAGE_CART_KEY);
      await removeOfflineValue(SALES_DRAFT_KEY);
      await removeOfflineValue(SALES_CART_KEY);
      await removeOfflineValue(SALES_STORAGE_CART_KEY);
      saveActionSet(false);
      savingRef.current = false;
      resetForm();
    };

    console.log("I am from sale: ", sale);
    saveActionSet(true);

    if (!isOnline) {
      await enqueueOfflineSale({
        endpoint,
        sale,
        cart,
        storageCart,
        action: saleAction,
      });
      await reconcileSaleStockCaches(cart, { refreshFromServer: false });
      setOfflineQueueCount(await getOfflineQueueCount());
      swal({
        title: "Sale saved offline",
        text: `Invoice ${sale_invoice || ""} is not saved on the server yet. It will sync automatically when the internet comes back.`,
        icon: "success",
      });
      await finalizeLocalSuccess();
      return true;
    }

    try {
      const res = await axios.post(
        `${API_URL}${endpoint}`,
        { cart, sale },
        { headers: { "auth-token": authInfo.token } }
      );

      if (!res.data.error) {
        reconcileSaleStockCaches(cart, { refreshFromServer: true }).catch((error) => {
          console.error("Failed to refresh sale stock cache after save:", error);
        });
        if (storageCart.length > 0) {
          // Reserved for later storage sync phase.
        }

        localStorage.removeItem(SALES_DRAFT_KEY);
        localStorage.removeItem(SALES_CART_KEY);
        localStorage.removeItem(SALES_STORAGE_CART_KEY);
        removeOfflineValue(SALES_DRAFT_KEY).catch(() => {});
        removeOfflineValue(SALES_CART_KEY).catch(() => {});
        removeOfflineValue(SALES_STORAGE_CART_KEY).catch(() => {});
        saveActionSet(false);
        savingRef.current = false;

        const successMsg =
          typeof res.data?.message === "string"
            ? res.data.message
            : res.data?.message?.msg || "Sale updated";

        swal({
          title: `${successMsg} successfully. Do you want to view invoice?`,
          icon: "success",
          buttons: true,
        }).then((confirm) => {
          if (confirm) {
            const invoiceSaleId =
              res.data?.message?.saleId ??
              res.data?.saleId ??
              saleId ??
              sale.sale_id ??
              null;

            if (invoiceSaleId != null && invoiceSaleId !== "") {
              history.push(`/sales/sales-invoice/${invoiceSaleId}`);
            } else {
              swal({
                title: "Invoice id not found",
                text: "Sale saved successfully, but the invoice id was not returned by the backend.",
                icon: "warning",
              });
            }
          } else {
            resetForm();
          }
        });
      } else {
        saveActionSet(false);
        savingRef.current = false;
        swal({
          title: "Sale not saved",
          text: `${res.data.message || "The sale could not be saved."}\n\nInvoice ${sale_invoice || ""} was not saved to the database.`,
          icon: "error",
          buttons: true,
        });
      }
    } catch (err) {
      saveActionSet(false);
      savingRef.current = false;

      if (err?.response) {
        const backendMessage =
          err.response?.data?.message ||
          err.response?.data?.error ||
          "The server rejected this sale. Please fix the issue and try again.";

        swal({
          title: "Sale not saved",
          text: `${backendMessage}\n\nInvoice ${sale_invoice || ""} was not saved to the database.`,
          icon: "error",
        });
        console.error(err);
        return false;
      }

      await enqueueOfflineSale({
        endpoint,
        sale,
        cart,
        storageCart,
        action: saleAction,
      });
      await reconcileSaleStockCaches(cart, { refreshFromServer: false });
      setOfflineQueueCount(await getOfflineQueueCount());
      swal({
        title: "Sale saved offline",
        text: `Invoice ${sale_invoice || ""} is not saved on the server yet. It will sync automatically when the internet comes back.`,
        icon: "warning",
      });
      await finalizeLocalSuccess();
      console.error(err);
    }
  };

  useEffect(() => {
    if (isDraftHydrating) return;
    if (!preserveLocationOnProductChange && !selectedProduct?.prod_rack_id && !selectedProduct?.prod_rack_name) {
      selectedRackSet(null);
    } else {
      setPreserveLocationOnProductChange(false);
    }
    selectedQuantitySet(null);
    setLocationRateOptions([]);
    setSelectedLocationRate(null);
  }, [selectedProduct]);

  useEffect(() => {
    if (!selectedProduct?.prod_id) return;
    const nextLabel = `${selectedProduct?.prod_code || ""} ${selectedProduct?.prod_name || ""}`.trim();
    if (nextLabel && !productSearchInput) {
      setProductSearchInput(nextLabel);
    }
  }, [selectedProduct, productSearchInput]);

  useEffect(() => {
    if (!selectedProduct?.prod_id) return;

    const nextBrand = getProductBrandName(selectedProduct);
    const nextCountry = getProductCountryName(selectedProduct);

    if (!product_brand && nextBrand) {
      product_brand_set(nextBrand);
    }
    if (!product_color && nextCountry) {
      product_color_set(nextCountry);
    }
  }, [selectedProduct, product_brand, product_color]);

  useEffect(() => {
    if (isDraftHydrating) return;
    if (selectedFloor?.prod_floor_id) {
      filterProductsByFloor(selectedFloor);
      return;
    }
    productsSet(applyCustomerTypeRates(allProducts, customer_type));
  }, [selectedFloor, allProducts, customer_type, isDraftHydrating]);

  useEffect(() => {
    const searchText = String(productSearchInput || "").trim();
    if (!searchText || searchText.length < 2 || !isOnline || !authInfo?.token) return undefined;

    const timer = setTimeout(() => {
      searchProductsForSale(searchText);
    }, 250);

    return () => clearTimeout(timer);
  }, [productSearchInput, isOnline, authInfo?.token]);

  useEffect(() => {
    let active = true;

    const refreshFloorStockSummary = async () => {
      if (!selectedFloor?.prod_floor_id || selectedProduct?.prod_id) {
        if (active) {
          setFloorStockSummary({
            productCount: 0,
            totalQty: 0,
            productNames: [],
            unitNames: [],
          });
        }
        return;
      }

      const cachedLocationRows = await loadSalesMasterData("product-locations", []);
      const nextSummary = buildFloorStockSummary(
        selectedFloor,
        products,
        cachedLocationRows
      );

      if (active) {
        setFloorStockSummary(nextSummary);
      }
    };

    refreshFloorStockSummary();
    return () => {
      active = false;
    };
  }, [selectedFloor, selectedProduct, products]);

  useEffect(() => {
    if (!selectedProduct?.prod_id) return;
    if (isFloorProductsLoading || productLookupLoading) return;
    const availableProducts = mergeUniqueProducts(products, allProducts);
    if (!Array.isArray(availableProducts) || availableProducts.length === 0) return;
    if (availableProducts.some((item) => normalizeProductId(item?.prod_id) === normalizeProductId(selectedProduct.prod_id))) return;

    selectedProductSet(null);
    selectedRackSet(null);
    selectedQuantitySet(null);
    setLocationRateOptions([]);
    setSelectedLocationRate(null);
    product_rate_set(0);
    product_brand_set("");
    product_color_set("");
    product_purchase_rate_set(0);
    product_qty_set("");
    product_total_set(0);
    enteredSetNoSet("");
  }, [products, allProducts, selectedProduct, isFloorProductsLoading, productLookupLoading]);

  useEffect(() => {
    if (isDraftHydrating) return;
    if (!preserveLocationOnProductChange) {
      selectedRackSet(null);
    }
    if (selectedProduct?.prod_id && selectedFloor?.prod_floor_id) {
      fetchRacks();
    }
  }, [selectedProduct, selectedFloor, product_brand, isDraftHydrating]);

  useEffect(() => {
    if (selectedProduct?.prod_id && selectedFloor?.prod_floor_id && selectedRack?.prod_rack_id) {
      fetchProductQuantity();
    }
  }, [selectedProduct, selectedFloor, selectedRack, isDraftHydrating]);

  useEffect(() => {
    if (!selectedProduct) {
      product_purchase_rate_set(0);
      return;
    }
    fetchProductLocationRate();
  }, [selectedProduct, selectedFloor, selectedRack, isDraftHydrating]);

  const handleBarcodeScan = async (barcodeValue) => {
    const prodId = parseInt(barcodeValue.trim());
    setResetKey(prev => prev + 1);

    if (!isNaN(prodId)) {
      selectedProductSet(null);
      product_rate_set(0);
      product_brand_set("");
      product_color_set("");
      product_purchase_rate_set(0)
      product_qty_set("");
      product_total_set(0);
      selectedRackSet(null);
      selectedQuantitySet(null);

      try {
        if (!isOnline) {
          const cachedProducts = await loadSalesMasterData("products", []);
          const scannedProduct = cachedProducts.find((product) => {
            const prodIdMatch = Number(product?.prod_id || 0) === prodId;
            const barcodeMatch = String(product?.prod_code || "").trim() === String(barcodeValue || "").trim();
            return prodIdMatch || barcodeMatch;
          });

          if (scannedProduct) {
            selectedProductSet(scannedProduct);
            product_rate_set(scannedProduct.prod_rate ?? scannedProduct.prod_sale_rate ?? 0);
            product_brand_set(getProductBrandName(scannedProduct));
            product_color_set(getProductCountryName(scannedProduct));
            product_purchase_rate_set(0);
            setLocationRateOptions([]);
            setSelectedLocationRate(null);
            selectedIdSet(scannedProduct.prod_id);
            floorRef.current.focus();
            return;
          }

          swal({ title: "Product not found in offline cache.", icon: "warning" });
          return;
        }

        const response = await axios.post(
          `${API_URL}/api/get-individual-products`,
          { productId: prodId },
          { headers: { "auth-token": authInfo.token } }
        );

        const scannedProduct = response.data.message?.[0];

        if (scannedProduct) {
          selectedProductSet(scannedProduct);
          product_rate_set(scannedProduct.prod_rate);
          product_brand_set(getProductBrandName(scannedProduct));
          product_color_set(getProductCountryName(scannedProduct));
          product_purchase_rate_set(0);
          setLocationRateOptions([]);
          setSelectedLocationRate(null);
          selectedIdSet(scannedProduct.prod_id);
          floorRef.current.focus();
        } else {
          swal({ title: "Product not found for scanned barcode.", icon: "warning" });
        }
      } catch (err) {
        console.error("Barcode scan failed:", err);
        swal({ title: "Failed to load product from barcode.", icon: "error" })
      }
    } else {
      swal({ title: "Invalid barcode!", icon: "warning" });
    }
  };

  const getProductLocationsForSelection = async (productId) => {
    if (!productId) return [];

    if (!isOnline) {
      return await loadProductLocationsFromCache(productId);
    }

    if (!Array.isArray(productLocationCacheRef.current[productId])) {
      try {
        const response = await axios.post(
          `${API_URL}/api/get-product-location`,
          { productId },
          { headers: { "auth-token": authInfo.token } }
        );
        await saveProductLocationsToCache(
          productId,
          Array.isArray(response?.data?.data) ? response.data.data : []
        );
      } catch (error) {
        console.error("Error fetching product locations for selection:", error);
        await saveProductLocationsToCache(productId, []);
      }
    }

    return productLocationCacheRef.current[productId] || [];
  };

  const hasSelectedProduct = selectedProduct != null;
  const hasSelectedFloor = selectedFloor?.prod_floor_id;
  const stockQtyDisplay = hasSelectedProduct
    ? product_total_stock_qty
    : hasSelectedFloor
      ? format(Number(floorStockSummary.totalQty || 0).toFixed(2))
      : "Stock Qty";
  const stockUnitDisplay = hasSelectedProduct
    ? selectedProduct.prod_unit_name || "Unit Name"
    : hasSelectedFloor
      ? floorStockSummary.unitNames.length > 0
        ? floorStockSummary.unitNames.join(", ")
        : `${floorStockSummary.productCount} unique product`
      : "Unit Name";
  const stockStatusDisplay = hasSelectedProduct
    ? parseFloat(product_total_stock_qty) > 0
      ? "Total Stock Available"
      : "Stock Unavailable"
    : hasSelectedFloor
      ? `${floorStockSummary.productCount} Unique Product`
      : "Stock Status";
  const stockNameDisplay = hasSelectedProduct
    ? selectedProduct.prod_name || ""
    : hasSelectedFloor
      ? floorStockSummary.productNames.length > 0
        ? floorStockSummary.productNames.join(", ")
        : "No stock item found"
      : "";
  const isStockAvailable = hasSelectedProduct
    ? parseFloat(product_total_stock_qty) > 0
    : hasSelectedFloor
      ? floorStockSummary.totalQty > 0
      : true;
  const selectedRateQuantityDisplay = hasSelectedProduct
    ? selectedLocationRate?.prod_qty ?? (locationRateOptions.length <= 1 ? selectedQuantity : "")
    : "";
  const productOptions = selectedFloor?.prod_floor_id
    ? mergeUniqueProducts(products, allProducts)
    : applyCustomerTypeRates(allProducts, customer_type);

  return (
    <div className={classes.root}>
      <Paper
        className={classes.paper}
        style={{ marginTop: "-25px", marginBottom: "5px" }}
        data-enter-flow-scope
      >
        <h4
          style={{
            textAlign: "left",
            margin: 0,
            padding: 0,
            marginTop: "-10px",
            marginBottom: "2px",
          }}
        >
          Sales Entry
        </h4>
        <div
          style={{
            textAlign: "left",
            fontSize: "12px",
            marginBottom: "10px",
            color: isOnline ? "#2e7d32" : "#b71c1c",
          }}
        >
          {isOnline
            ? `Online mode active${offlineQueueCount > 0 ? `, ${offlineQueueCount} sale(s) waiting to sync` : ""}.`
            : `Offline mode active. ${offlineQueueCount} sale(s) queued for sync.`}
        </div>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={2}>
            <TextField
              label="invoice no"
              variant="outlined"
              value={sale_invoice}
              disabled
              className={classes.fullWidth}
              onChange={(e) => sale_invoice_set(e.target.value)}
              name="sale_invoice"
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              label="Chalan No"
              variant="outlined"
              value={po_id}
              className={classes.fullWidth}
              onChange={(e) => po_id_set(e.target.value)}
              name="sale_invoice"
              inputRef={poRef}
              inputProps={{ "data-enter-order": "10" }}
              onKeyDown={(e) => { if (e.key === "Enter") employeeRef.current?.focus(); }}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Autocomplete
              size="small"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setTimeout(() => floorRef.current?.focus(), 0);
                }
              }}
              value={selectedEmployee}
              openOnFocus={true}
              autoHighlight={true}
              style={{ width: "100%", height: "20px" }}
              loading={true}
              options={employees}
              getOptionSelected={(option, value) => option?.employee_id === value?.employee_id}
              onChange={(e, employee) => {
                selectedEmployeeSet(employee);
                setTimeout(() => floorRef.current?.focus(), 0);
              }}
              getOptionLabel={(option) => option.employee_name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  inputRef={employeeRef}
                  inputProps={{
                    ...params.inputProps,
                    "data-enter-order": "20",
                  }}
                  label="Sales by"
                  variant="outlined"
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={2}>
            <Autocomplete
              autoHighlight={true}
              size="small"
              openOnFocus={true}
              style={{ width: "100%" }}
              options={floors || []}
              value={selectedFloor}
              getOptionSelected={(option, value) => option?.prod_floor_id === value?.prod_floor_id}
              loading={false}
              onKeyDown={(e) => { if (e.key === "Enter") setTimeout(() => dateRef.current?.focus(), 0); }}
              onChange={(e, customer) => {
                selectedFloorSet(customer);
                if (customer?.prod_floor_id) {
                  filterProductsByFloor(customer, allProducts);
                } else {
                  productsSet(applyCustomerTypeRates(allProducts, customer_type));
                }
                selectedProductSet(null);
                selectedRackSet(null);
                selectedQuantitySet(null);
                product_rate_set(0);
                product_brand_set("");
                product_color_set("");
                product_purchase_rate_set(0);
                product_qty_set("");
                product_total_set(0);
                enteredSetNoSet("");
                setTimeout(() => dateRef.current?.focus(), 0);
              }}
              getOptionLabel={(option) => option.prod_floor_name || ""}
              renderInput={(params) => (
                <TextField
                  inputRef={floorRef}
                  {...params}
                  inputProps={{
                    ...params.inputProps,
                    "data-enter-order": "30",
                  }}
                  label="Choose a Floor"
                  variant="outlined"
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={2}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                style={{ width: "100%", marginTop: "" }}
                value={selectedDate}
                inputRef={dateRef}
                inputProps={{
                  "data-enter-flow": "off",
                  "data-enter-order": "40",
                }}
                onKeyDown={(e) => {
                  if (e.key == "Enter") {
                    e.preventDefault();
                    e.stopPropagation();
                    setTimeout(() => customerRef.current?.focus(), 0);
                  }
                }}
                onChange={handleDateChangeSet}
                name="sale_date"
                label="Sales Date"
                format="yyyy/MM/dd"
              />
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
      </Paper>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={8}>
          <Paper className={classes.paper} data-enter-flow-scope>
            <h4
              style={{
                textAlign: "left",
                margin: 0,
                padding: 0,
                marginTop: "-10px",
                marginBottom: "0px",
              }}
            >
              Customer & Product Information
            </h4>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={5} className={classes.plusLinkDiv}>
                <Grid item xs={12} sm={5}>
                  <FormControl component="fieldset">
                    <RadioGroup
                      row
                      aria-label="customer_type"
                      name="position"
                      style={{ display: "flex", flexWrap: "initial" }}
                      defaultValue={customer_type}
                      onChange={(e) => {
                        customer_type_set(e.target.value);
                      }}
                    >
                      <FormControlLabel
                        value="retail"
                        control={<Radio color="primary" />}
                        label="Retail "
                      />
                      <FormControlLabel
                        value="wholesale"
                        control={<Radio color="primary" />}
                        label="WholeSale "
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>

                <Link className={classes.plusLink} to="/sales/customers-manage">
                  +
                </Link>
                <Autocomplete
                  autoHighlight={true}
                  size="small"
                  openOnFocus={true}
                  style={{ width: "100%" }}
                  options={customers}
                  value={selectedCustomer}
                  getOptionSelected={(option, value) => option?.customer_id === value?.customer_id}
                  loading={true}
                  onKeyDown={(e) => { if (e.key === "Enter") setTimeout(() => { general_customer ? customerNameRef.current?.focus() : contactPersonRef.current?.focus(); }, 0); }}
                  onChange={async (e, customer) => {
                    selectedCustomerSet(customer);
                    if (customer == null) {
                      customer_name_set("");
                      customer_mobile_no_set("");
                      customer_address_set("");
                      general_customer_set(false);
                      return false;
                    }
                    const nextCustomerName =
                      customer.customer_name ||
                      customer.display_text ||
                      customer.customer_full_name ||
                      "";
                    const nextCustomerMobile =
                      customer.customer_mobile_no ||
                      customer.customer_mobile ||
                      customer.mobile_no ||
                      "";
                    const nextCustomerAddress =
                      customer.customer_address ||
                      customer.address ||
                      customer.customer_addr ||
                      "";

                    customer_name_set(nextCustomerName);
                    customer_mobile_no_set(nextCustomerMobile);
                    customer_address_set(nextCustomerAddress);

                    if (customer.customer_id == 0 || customer.customer_type === "general") {
                      general_customer_set(true);
                      previous_due_set(0);
                    } else {
                      general_customer_set(false);
                      customer_credit_limit_set(
                        Number(
                          customer.customer_credit_limit ??
                          customer.credit_limit ??
                          customer.customer_credit ??
                          0
                        )
                      );
                      previous_due_set(
                        Number(
                          customer.customer_due ??
                          customer.dueAmount ??
                          customer.current_due ??
                          0
                        )
                      );
                      try {
                        const dueResponse = await axios.post(
                          `${API_URL}/api/get-customer-due`,
                          { customerId: customer.customer_id },
                          { headers: { "auth-token": authInfo.token } }
                        );
                        const dueAmount = Array.isArray(dueResponse?.data) && dueResponse.data.length > 0
                          ? Number(dueResponse.data[0]?.dueAmount || 0)
                          : 0;
                        previous_due_set(dueAmount);
                      } catch (_error) {
                        previous_due_set(0);
                      }
                    }
                    setTimeout(() => {
                      if (customer?.customer_id === 0 || customer?.customer_type === "general") {
                        customerNameRef.current?.focus();
                      } else {
                        contactPersonRef.current?.focus();
                      }
                    }, 0);
                  }}
                  getOptionLabel={(option) =>
                    option?.display_text ||
                    option?.customer_name ||
                    option?.customer_full_name ||
                    ""
                  }
                  renderInput={(params) => (
                    <TextField
                      inputRef={customerRef}
                      {...params}
                      inputProps={{
                        ...params.inputProps,
                        "data-enter-order": "10",
                      }}
                      label="Choose a customer"
                      variant="outlined"
                    />
                  )}
                />

                <TextField
                  autoComplete="off"
                  style={{ display: general_customer == true ? "" : "none" }}
                  label="customer name"
                  variant="outlined"
                  className={classes.inputField}
                  value={customer_name}
                  onChange={(e) => customer_name_set(e.target.value)}
                  name="customer_name"
                  inputRef={customerNameRef}
                  inputProps={{ "data-enter-order": "20" }}
                  onKeyDown={(e) => { if (e.key === "Enter") customerMobileRef.current?.focus(); }}
                />
                <TextField
                  autoComplete="off"
                  disabled={general_customer == true ? false : true}
                  label="customer mobile"
                  variant="outlined"
                  className={classes.inputField}
                  value={customer_mobile_no}
                  onChange={(e) => customer_mobile_no_set(e.target.value)}
                  name="customer_mobile_no"
                  inputRef={customerMobileRef}
                  inputProps={{ "data-enter-order": "30" }}
                  onKeyDown={(e) => { if (e.key === "Enter") customerAddressRef.current?.focus(); }}
                />
                <TextField
                  autoComplete="off"
                  disabled={general_customer == true ? false : true}
                  label="customer address"
                  variant="outlined"
                  className={classes.inputField}
                  value={customer_address}
                  onChange={(e) => customer_address_set(e.target.value)}
                  name="customer_address"
                  inputRef={customerAddressRef}
                  inputProps={{ "data-enter-order": "40" }}
                  onKeyDown={(e) => { if (e.key === "Enter") contactPersonRef.current?.focus(); }}
                />

                <br />
                <br />
                <Autocomplete
                  autoHighlight={true}
                  size="small"
                  openOnFocus={true}
                  style={{ width: "100%" }}
                  options={contactPersons || []}
                  value={selectedContactPerson}
                  getOptionSelected={(option, value) => option?.contact_person_id === value?.contact_person_id}
                  loading={false}
                  onKeyDown={(e) => { if (e.key === "Enter") setTimeout(() => productRef.current?.focus(), 0); }}
                  onChange={async (e, customer) => {
                    selectedContactPersonSet(customer);
                    setTimeout(() => productRef.current?.focus(), 0);
                  }}
                  getOptionLabel={(option) => option.contact_person_name || ""}
                  renderInput={(params) => (
                    <TextField
                      inputRef={contactPersonRef}
                      {...params}
                      inputProps={{
                        ...params.inputProps,
                        "data-enter-order": "50",
                      }}
                      label="Choose a Contact Person"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={5}
                className={classes.plusLinkDiv}
                style={{ marginTop: "5px" }}
              >
                <Link
                  className={classes.plusLink}
                  to="/administration/products-manage"
                >
                  +
                </Link>
                <Autocomplete
                  openOnFocus={true}
                  autoHighlight={true}
                  style={{ width: "100%", height: "20px" }}
                  options={productOptions}
                  value={selectedProduct}
                  getOptionSelected={(option, value) => normalizeProductId(option?.prod_id) === normalizeProductId(value?.prod_id)}
                  inputValue={productSearchInput}
                  loading={isFloorProductsLoading || productLookupLoading}
                  size="small"
                  onKeyDown={handleProductEnter}
                  filterOptions={(options, state) =>
                    sortProductsBySearchInput(options, state.inputValue).slice(0, 50)
                  }
                  noOptionsText={
                    selectedFloor?.prod_floor_id
                      ? "No product found. It may be available on another floor."
                      : "No product found"
                  }
                  getOptionLabel={(option) => `${option?.prod_code || ""} ${option?.prod_name || ""}`.trim()}
                  onInputChange={(event, value, reason) => {
                    if (reason === "input") {
                      setProductSearchInput(value || "");
                      if (selectedProduct && String(value || "").trim() === "") {
                        selectedProductSet(null);
                      }
                    }
                    if (reason === "clear") {
                      setProductSearchInput("");
                      selectedProductSet(null);
                    }
                  }}
                onChange={async (e, product, reason) => {
                  if (product == null) {
                    if (reason !== "clear") return false;
                    setProductSearchInput("");
                    product_rate_set(0);
                    product_qty_set("");
                    product_brand_set("");
                    product_color_set("");
                    product_purchase_rate_set(0);
                    setLocationRateOptions([]);
                    setSelectedLocationRate(null);
                    selectedProductSet(null);
                    return false;
                  }

                  const productBrandName = getProductBrandName(product);
                  const productCountryName = getProductCountryName(product);
                  setProductSearchInput(`${product?.prod_code || ""} ${product?.prod_name || ""}`.trim());
                  product_rate_set(product.prod_rate);
                  product_brand_set(productBrandName);
                  product_color_set(productCountryName);
                  product_purchase_rate_set(0);
                  setLocationRateOptions([]);
                  setSelectedLocationRate(null);
                  const locationRows = await getProductLocationsForSelection(product.prod_id);
                  const selectedFloorId = Number(selectedFloor?.prod_floor_id || 0);
                  const availableLocations = (Array.isArray(locationRows) ? locationRows : [])
                    .filter((row) => Number(row?.prod_qty || row?.current_stock || 0) > 0);
                  const preferredLocation =
                    availableLocations.find((row) => Number(row?.prod_floor_id || 0) === selectedFloorId) ||
                    availableLocations[0] ||
                    locationRows[0] ||
                    null;
                  const nextFloor = preferredLocation?.prod_floor_id
                    ? {
                      prod_floor_id: preferredLocation.prod_floor_id,
                      prod_floor_name: preferredLocation.prod_floor_name || product.prod_floor_name || "",
                    }
                    : product?.prod_floor_id
                      ? {
                        prod_floor_id: product.prod_floor_id,
                        prod_floor_name: product.prod_floor_name || "",
                      }
                      : null;
                  const nextRack = preferredLocation?.prod_rack_id
                    ? {
                      prod_rack_id: preferredLocation.prod_rack_id,
                      prod_rack_name: preferredLocation.prod_rack_name || product.prod_rack_name || "",
                    }
                    : product?.prod_rack_id
                      ? {
                        prod_rack_id: product.prod_rack_id,
                        prod_rack_name: product.prod_rack_name || "",
                      }
                      : null;
                  const nextProduct = {
                    ...product,
                    prod_brand: productBrandName,
                    prod_brand_name: productBrandName,
                    prod_color: productCountryName,
                    prod_color_name: productCountryName,
                    prod_floor_id: nextFloor?.prod_floor_id || product.prod_floor_id,
                    prod_floor_name: nextFloor?.prod_floor_name || product.prod_floor_name,
                    prod_rack_id: nextRack?.prod_rack_id || product.prod_rack_id,
                    prod_rack_name: nextRack?.prod_rack_name || product.prod_rack_name,
                    prod_purchase_rate: preferredLocation?.prod_purchase_rate ?? product.prod_purchase_rate,
                    storage_batch_id: preferredLocation?.storage_batch_id ?? product.storage_batch_id,
                  };
                  if (nextFloor) {
                    selectedFloorSet(nextFloor);
                  }
                  if (nextRack) {
                    setPreserveLocationOnProductChange(true);
                    selectedRackSet(nextRack);
                  }
                  selectedIdSet(product.prod_id);
                  selectedProductSet(nextProduct);
                  focusRef(brandRef);
                }}
                  renderInput={(params) => (
                    <TextField
                      inputRef={productRef}
                      {...params}
                      inputProps={{
                        ...params.inputProps,
                        "data-enter-order": "60",
                      }}
                      label="choose a product"
                      variant="outlined"
                    />
                  )}
                />

                <input
                  type="text"
                  onKeyDown={async (e) => {
                    if (e.key === 'Enter') {
                      const scannedCode = e.target.value.trim();
                      e.target.value = '';
                      if (scannedCode) {
                        await handleBarcodeScan(scannedCode);

                      }
                    }
                  }}
                  placeholder="Scan barcode..."
                  style={{
                    position: 'absolute',
                    opacity: 0,
                    pointerEvents: 'none',
                    top: '-1000px'
                  }}

                  autoFocus
                // key={`barcode-input-${resetKey}`}

                />

                <br />

                <Grid container>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      type="text"
                      style={{ marginRight: "5px" }}
                      label="brand"
                      variant="outlined"
                      className={classes.inputField}
                      value={product_brand}
                      onChange={(e) => {
                        product_brand_set(e.target.value);
                      }}
                      inputRef={brandRef}
                      inputProps={{ "data-enter-order": "70" }}
                      onKeyDown={(e) => {
                        if (e.key == "Enter") {
                          countryRef.current.focus();
                        }
                      }}
                    />
                  </Grid>
                  <Grid item sm={1}></Grid>
                  <Grid item xs={12} sm={5}>
                    <TextField
                      type="text"
                      label="country"
                      variant="outlined"
                      className={classes.inputField}
                      value={product_color}
                      onChange={(e) => {
                        product_color_set(e.target.value);
                      }}
                      inputRef={countryRef}
                      inputProps={{ "data-enter-order": "80" }}
                      onKeyDown={(e) => {
                        if (e.key == "Enter") {
                          rackRef.current.focus();
                        }
                      }}
                    />
                  </Grid>
                </Grid>

                <br />

                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Autocomplete
                      autoHighlight={true}
                      size="small"
                      openOnFocus={true}
                      style={{ width: "100%" }}
                      options={racks || []}
                      value={selectedRack}
                      getOptionSelected={(option, value) => option?.prod_rack_id === value?.prod_rack_id}
                      loading={false}
                      disabled={!selectedFloor?.prod_floor_id || !selectedProduct?.prod_id}
                      onKeyDown={(e) => { if (e.key === "Enter") setTimeout(() => purchaseRateRef.current?.focus(), 0); }}
                      onChange={async (e, customer) => {
                        selectedRackSet(customer);
                        product_qty_set("");
                        setTimeout(() => purchaseRateRef.current?.focus(), 0);
                      }}
                      getOptionLabel={(option) => option.prod_rack_name || ""}
                      renderInput={(params) => (
                        <TextField
                          inputRef={rackRef}
                          {...params}
                          inputProps={{
                            ...params.inputProps,
                            "data-enter-order": "90",
                          }}
                          label="Choose a Rack"
                          variant="outlined"
                        />
                      )}
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={2} style={{ marginTop: "8px" }}>
                  <Grid item xs={12}>
                    <Autocomplete
                      autoHighlight={true}
                      size="small"
                      openOnFocus={true}
                      style={{ width: "100%" }}
                      options={locationRateOptions || []}
                      value={selectedLocationRate}
                      getOptionSelected={(option, value) =>
                        getLocationRateKey(option) === getLocationRateKey(value)
                      }
                      loading={false}
                      disabled={!selectedFloor?.prod_floor_id || !selectedRack?.prod_rack_id || locationRateOptions.length === 0}
                      onKeyDown={(e) => { if (e.key === "Enter") setTimeout(() => rateRef.current?.focus(), 0); }}
                      noOptionsText={
                        selectedFloor?.prod_floor_id && selectedRack?.prod_rack_id
                          ? "No purchase rate found for this floor/rack"
                          : "Select floor and rack first"
                      }
                      getOptionLabel={(option) =>
                        option
                          ? `Rate ${normalizePurchaseRate(option?.prod_purchase_rate).toFixed(2)} | Qty ${num(option?.prod_qty).toFixed(0)} pcs`
                          : ""
                      }
                      onChange={(e, row) => {
                        applyLocationRateSelection(row);
                        setTimeout(() => rateRef.current?.focus(), 0);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Choose Purchase Rate"
                          variant="outlined"
                          inputRef={purchaseRateRef}
                          inputProps={{
                            ...params.inputProps,
                            "data-enter-order": "100",
                          }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>


                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      type="number"
                      label="Purchase Rate"
                      variant="outlined"
                      size="small"
                      disabled={true}
                      className={classes.inputField}
                      value={product_purchase_rate}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      InputProps={{ style: { backgroundColor: "#f5f5f5" } }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      type="number"
                      label="Sale Rate"
                      variant="outlined"
                      size="small"
                      className={classes.inputField}
                      value={product_rate}
                      onChange={(e) => product_rate_set(e.target.value)}
                      inputRef={rateRef}
                      inputProps={{ "data-enter-order": "110" }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") qtyRef.current.focus();
                      }}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      type="number"
                      label="Piece Qty"
                      variant="outlined"
                      size="small"
                      className={classes.inputField}
                      value={product_qty}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (val === "" || /^\d+$/.test(val)) {
                          product_qty_set(val);
                        }
                      }}
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-", "."].includes(e.key)) {
                          e.preventDefault();
                        }
                        if (e.key === "Enter") {
                          if (selectedProduct?.prod_set_qty && !enteredSetNo) {
                            enteredSetNoRef.current?.focus();
                          } else {
                            addToCartRef.current?.click();
                          }
                        }
                      }}
                      inputRef={qtyRef}
                      inputProps={{ "data-enter-order": "120" }}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  {/* Set Calculation Section */}
                  <Grid item xs={12} style={{ marginTop: "10px", padding: "10px", backgroundColor: "#f9f9f9", borderRadius: "5px", border: "1px solid #eee" }}>
                    <div style={{ fontSize: "12px", color: "#666", marginBottom: "8px", fontWeight: "bold" }}>Set Calculation Info</div>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={3}>
                        <TextField
                          label="Unit Name"
                          value={selectedProduct?.prod_unit_name || ""}
                          variant="outlined"
                          size="small"
                          fullWidth
                          disabled
                          className={classes.inputField}
                          InputProps={{ readOnly: true, style: { fontSize: "13px" } }}
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <TextField
                          label="Set Unit"
                          value={selectedProduct?.prod_set_no || ""}
                          variant="outlined"
                          size="small"
                          fullWidth
                          disabled
                          className={classes.inputField}
                          InputProps={{ readOnly: true, style: { fontSize: "13px" } }}
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <TextField
                          label="No. of Sets"
                          type="number"
                          value={enteredSetNo}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val === "" || /^\d+$/.test(val)) {
                              enteredSetNoSet(val);
                            }
                          }}
                          onKeyDown={(e) => {
                            if (["e", "E", "+", "-", "."].includes(e.key)) {
                              e.preventDefault();
                            }
                            if (e.key === "Enter") {
                              addToCartRef.current?.click();
                            }
                          }}
                          inputRef={enteredSetNoRef}
                          inputProps={{ "data-enter-order": "130" }}
                          variant="outlined"
                          size="small"
                          fullWidth
                          className={classes.inputField}
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <TextField
                          label="Qty/Set"
                          value={selectedProduct?.prod_set_qty ? parseInt(selectedProduct.prod_set_qty) : ""}
                          variant="outlined"
                          size="small"
                          fullWidth
                          disabled
                          className={classes.inputField}
                          InputProps={{ readOnly: true, style: { fontSize: "13px" } }}
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} style={{ marginTop: "5px" }}>
                    <TextField
                      label="Total Amount"
                      variant="outlined"
                      value={product_total}
                      onChange={(e) => product_total_set(e.target.value)}
                      disabled
                      size="small"
                      className={classes.inputField}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      InputProps={{ style: { fontWeight: "bold", color: "#333" } }}
                    />
                  </Grid>
                </Grid>


                <Grid container justifyContent="flex-end" style={{ marginTop: "10px" }}>
                  <Button
                    style={{
                      padding: "8px 24px",
                      fontSize: "15px",
                      fontWeight: "bold",
                      textTransform: "none",
                      borderRadius: "8px",
                      boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                      transition: "all 0.2s"
                    }}
                    buttonRef={addToCartRef}
                    data-enter-order="140"
                    variant="contained"
                    color="secondary"
                    size="medium"
                    onClick={() => productToCart()}
                    className={classes.button}
                    startIcon={<SaveIcon />}
                  >
                    {editCartIndex !== null ? "Update Cart Item" : "Add To Cart"}
                  </Button>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={2}>
                <strong
                  style={{
                    color:
                      isStockAvailable ? "green" : "red",
                    fontSize: "12px",
                  }}
                  className={"stock-info-msg"}
                >
                  {stockStatusDisplay}
                </strong>
                <div className={"stock-info"}>
                  <strong
                    style={{
                      color: isStockAvailable ? "green" : "red",
                      fontSize: "12px",
                    }}
                  >
                    {stockQtyDisplay}
                  </strong>
                  <p style={{ color: "#005600", fontSize: "12px" }}>
                    {stockUnitDisplay}
                  </p>
                  {stockNameDisplay ? (
                    <p
                      title={stockNameDisplay}
                      style={{
                        color: "#005600",
                        fontSize: "11px",
                        margin: 0,
                        padding: "0 6px 6px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {stockNameDisplay}
                    </p>
                  ) : null}
                </div>
                <div
                  className={"stock-info-purchaserate"}
                  onClick={() => {
                    purchaseRateShowAction();
                  }}
                >
                    <input
                      type={purchaseRateShow ? "password" : "text"}
                      value={
                        selectedProduct != null
                          ? parseFloat(
                            selectedLocationRate?.prod_purchase_rate ??
                            product_purchase_rate ??
                            selectedProduct.prod_purchase_rate ??
                            0
                          ).toFixed(2)
                          : "Purchase Rate"
                      }
                      disabled
                    ></input>
                </div>
                <div>
                  <h1 style={{ color: "black" }}>
                    {selectedRateQuantityDisplay || ""}
                  </h1>
                </div>
              </Grid>
            </Grid>
          </Paper>

          <Grid container>
            <Grid item xs={12}>
              <Paper className={classes.paper} style={{ marginTop: "5px" }}>
                <h4
                  style={{
                    textAlign: "left",
                    margin: 0,
                    padding: 0,
                    marginTop: "-10px",
                    marginBottom: "3px",
                  }}
                >
                  Sales Cart
                </h4>
                <TableContainer>
                  <Table
                    className={classes.table}
                    size="small"
                    aria-label="a dense table"
                  >
                    <TableHead>
                      <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                        <TableCell align="center" style={{ fontWeight: "bold", width: "50px" }}>SL</TableCell>
                        <TableCell align="left" style={{ fontWeight: "bold" }}>Product</TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold" }}>Brand</TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold" }}>Country</TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold" }}>Floor</TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold" }}>Rack</TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold", whiteSpace: "nowrap" }}>Rate</TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold" }}>Qty</TableCell>
                        <TableCell align="right" style={{ fontWeight: "bold" }}>Subtotal</TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold" }}>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {cart.map((product, sl) => {
                        const lineSubtotal = parseFloat(product.prod_total);
                        const lineDiscount = 0;
                        const lineVat = (lineSubtotal * parseFloat(vat_percent || 0)) / 100;
                        const lineAit = (lineSubtotal * parseFloat(ait_percent || 0)) / 100;
                        const lineTransport = 0;
                        const lineTotal = lineSubtotal - lineDiscount + lineVat + lineAit + lineTransport;

                        return (
                          <TableRow key={parseFloat(sl) + 1}>
                            <TableCell align="center">{parseFloat(sl) + 1}</TableCell>
                            <TableCell align="left">
                              {product.prod_name}
                            </TableCell>
                            <TableCell align="center">{product.prod_brand}</TableCell>
                            <TableCell align="center">{product.prod_color}</TableCell>
                            <TableCell align="center">
                              {product.prod_floor_name}
                            </TableCell>
                            <TableCell align="center">
                              {product.prod_rack_name}
                            </TableCell>
                            <TableCell align="center">
                              {product.prod_sale_rate}
                            </TableCell>
                            <TableCell align="center">
                              {product.prod_qty}
                            </TableCell>
                            <TableCell align="right">
                              {format(lineSubtotal.toFixed(2))}
                            </TableCell>
                            <TableCell align="center">
                              <EditIcon
                                style={{
                                  cursor: "pointer",
                                  color: "#0f7e77",
                                  marginRight: "8px",
                                }}
                                onClick={() => {
                                  cartToEdit(sl);
                                }}
                              />
                              <RemoveCircleIcon
                                style={{
                                  cursor: "pointer",
                                  color: "#FF0202",
                                  marginLeft: "2px",
                                }}
                                onClick={() => {
                                  cartFromRemove(sl);
                                }}
                              ></RemoveCircleIcon>
                            </TableCell>
                          </TableRow>
                        )
                      })}

                      {cart.length != 0 ? (
                        <TableRow style={{ backgroundColor: "#fafafa" }}>
                          <TableCell
                            colSpan={8}
                            align="right"
                            style={{ fontWeight: "bold", fontSize: "14px" }}
                          >
                            Total Amount:
                          </TableCell>
                          <TableCell
                            align="right"
                            style={{ fontWeight: "bold", fontSize: "14px" }}
                          >
                            {" "}
                            {format(parseFloat(total_amount).toFixed(2))}
                          </TableCell>
                          <TableCell />
                        </TableRow>
                      ) : (
                        <TableRow>
                          <TableCell colSpan={14} align="center">
                            Cart is empty.
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

                {cart.length !== 0 && (
                  <TableContainer style={{ marginTop: "10px" }}>
                    <Table className={classes.table} size="small">
                      <TableBody>
                        <TableRow>
                          <TableCell align="right" style={{ fontWeight: "bold", border: "none", paddingRight: "20px" }}>
                            Subtotal:
                          </TableCell>
                          <TableCell align="right" style={{ border: "none", paddingRight: "20px", minWidth: "120px" }}>
                            {format(parseFloat(sub_total || 0).toFixed(2))}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell align="right" style={{ fontWeight: "bold", border: "none", paddingRight: "20px" }}>
                            Discount ({discount_percent}%):
                          </TableCell>
                          <TableCell align="right" style={{ border: "none", paddingRight: "20px" }}>
                            -{format(parseFloat(discount || 0).toFixed(2))}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell align="right" style={{ fontWeight: "bold", border: "none", paddingRight: "20px" }}>
                            VAT ({vat_percent}%):
                          </TableCell>
                          <TableCell align="right" style={{ border: "none", paddingRight: "20px" }}>
                            +{format(parseFloat(vat || 0).toFixed(2))}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell align="right" style={{ fontWeight: "bold", border: "none", paddingRight: "20px" }}>
                            AIT ({ait_percent}%):
                          </TableCell>
                          <TableCell align="right" style={{ border: "none", paddingRight: "20px" }}>
                            +{format(parseFloat(ait || 0).toFixed(2))}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell align="right" style={{ fontWeight: "bold", border: "none", paddingRight: "20px" }}>
                            Transport Cost:
                          </TableCell>
                          <TableCell align="right" style={{ border: "none", paddingRight: "20px" }}>
                            +{format(parseFloat(transport_cost || 0).toFixed(2))}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell align="right" style={{ fontWeight: "bold", fontSize: "16px", borderTop: "2px solid #333", paddingRight: "20px" }}>
                            Grand Total:
                          </TableCell>
                          <TableCell align="right" style={{ fontWeight: "bold", fontSize: "16px", borderTop: "2px solid #333", paddingRight: "20px" }}>
                            {format(parseFloat(total_amount || 0).toFixed(2))}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}

                <TableContainer>
                  <Table
                    className={classes.table}
                    size="small"
                    aria-label="a dense table"
                  >
                    {cart.length != 0 ? (
                      <TableRow>
                        <TableCell style={{ width: "325px" }}>
                          <TextareaAutosize
                            onChange={(e) => {
                              note_set(e.target.value);
                            }}
                            name="note"
                            style={{
                              float: "left",
                              marginTop: "20px",
                              width: "325px",
                            }}
                            aria-label="Sale Note..."
                            rowsMin={3}
                            placeholder="Sales Note..."
                          />
                        </TableCell>

                        <TableCell colSpan={2}></TableCell>
                      </TableRow>
                    ) : (
                      ""
                    )}
                  </Table>
                </TableContainer>
              </Paper>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={4}>
          <Paper className={classes.paper} data-enter-flow-scope>
            <h4
              style={{
                textAlign: "left",
                margin: 0,
                padding: 0,
                marginTop: "-10px",
                marginBottom: "3px",
              }}
            >
              Amount Details
            </h4>
            <Grid container style={{ paddingRight: "1px" }}>
              <Grid item xs={12} sm={5}>
                <TextField
                  type="text"
                  style={{ marginRight: "5px" }}
                  label="Subtotal"
                  size="small"
                  disabled
                  value={sub_total}
                  name="sub_total"
                  onChange={(e) => sub_total_set(e.target.value)}
                  variant="outlined"
                  className={classes.inputField}
                  inputProps={decimalInputProps}
                />
              </Grid>
              <Grid item xs={0} sm={1}></Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  type="text"
                  style={{ marginRight: "5px" }}
                  size="small"
                  value={previous_due}
                  name="previous_due"
                  onChange={(e) => previous_due_set(e.target.value)}
                  label="Current due"
                  disabled
                  variant="outlined"
                  className={classes.inputField}
                  inputProps={decimalInputProps}
                />
              </Grid>
            </Grid>

            {/* VAT */}
            <Grid container>
              <Grid item xs={12} sm={5}>
                <TextField
                  type="text"
                  label="VAT (TK)"
                  value={vat}
                  name="vat"
                  onChange={handleVatInput}
                  variant="outlined"
                  size="small"
                  className={classes.inputField}
                  inputRef={vatRef}
                  disabled={true}
                  InputProps={{ readOnly: true }}
                  inputProps={decimalInputProps}
                  onKeyDown={(e) => { if (e.key === "Enter") vatPercentRef.current?.focus(); }}
                />
              </Grid>
              <Grid item xs={0} sm={1}></Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  type="text"
                  label="VAT (%)"
                  variant="outlined"
                  size="small"
                  className={classes.inputField}
                  value={vat_percent}
                  name="vat_percent"
                  onChange={handleVatInput}
                  inputRef={vatPercentRef}
                  inputProps={decimalInputProps}
                  onKeyDown={(e) => { if (e.key === "Enter") aitPercentRef.current?.focus(); }}
                />
              </Grid>
            </Grid>

            {/* AIT */}
            <Grid container>
              <Grid item xs={12} sm={5}>
                <TextField
                  type="text"
                  label="AIT (TK)"
                  value={ait}
                  name="ait"
                  onChange={handleAitInput}
                  variant="outlined"
                  size="small"
                  className={classes.inputField}
                  inputRef={aitRef}
                  disabled={true}
                  InputProps={{ readOnly: true }}
                  inputProps={decimalInputProps}
                  onKeyDown={(e) => { if (e.key === "Enter") aitPercentRef.current?.focus(); }}
                />
              </Grid>
              <Grid item xs={0} sm={1}></Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  type="text"
                  label="AIT (%)"
                  variant="outlined"
                  size="small"
                  className={classes.inputField}
                  value={ait_percent}
                  name="ait_percent"
                  onChange={handleAitInput}
                  inputRef={aitPercentRef}
                  inputProps={decimalInputProps}
                  onKeyDown={(e) => { if (e.key === "Enter") discountRef.current?.focus(); }}
                />
              </Grid>
            </Grid>

            {/* Discount */}
            <Grid container style={{ paddingRight: "1px" }}>
              <Grid item xs={12} sm={5}>
                <TextField
                  type="text"
                  style={{ marginRight: "5px" }}
                  size="small"
                  label="Discount(TK)"
                  variant="outlined"
                  className={classes.inputField}
                  value={discount}
                  name="discount"
                  onChange={handleDiscountInput}
                  inputRef={discountRef}
                  inputProps={decimalInputProps}
                  onKeyDown={(e) => { if (e.key === "Enter") discountPercentRef.current?.focus(); }}
                />
              </Grid>
              <Grid item xs={0} sm={1}></Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  type="text"
                  label="Discount (%)"
                  size="small"
                  variant="outlined"
                  className={classes.inputField}
                  value={discount_percent}
                  name="discount_percent"
                  onChange={handleDiscountInput}
                  inputRef={discountPercentRef}
                  inputProps={decimalInputProps}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      transportRef.current.focus();
                    }
                  }}
                />
              </Grid>
            </Grid>

            {/* Total / Transport */}
            <Grid container style={{ paddingRight: "1px" }}>
              <Grid item xs={12} sm={5}>
                <TextField
                  type="text"
                  style={{ marginRight: "5px" }}
                  size="small"
                  label="Total"
                  disabled
                  variant="outlined"
                  className={classes.inputField}
                  value={total_amount}
                  name="total_amount"
                  onChange={(e) => total_amount_set(e.target.value)}
                  inputProps={decimalInputProps}
                />
              </Grid>
              <Grid item xs={0} sm={1}></Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  type="text"
                  style={{ marginRight: "5px" }}
                  size="small"
                  label="Transport Cost"
                  variant="outlined"
                  className={classes.inputField}
                  value={transport_cost}
                  name="transport_cost"
                  onChange={(e) => transport_cost_set(normalizeDecimalInput(e.target.value))}
                  inputRef={transportRef}
                  inputProps={decimalInputProps}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      paidRef.current.focus();
                    }
                  }}
                />
              </Grid>
            </Grid>


            <Grid container style={{ paddingRight: "1px" }}>
              <Grid item xs={12} sm={5}>
                <TextField
                  type="text"
                  label="Paid"
                  variant="outlined"
                  size="small"
                  className={classes.inputField}
                  value={paid}
                  name="paid"
                  onChange={(e) => {
                    selectedCustomerPayMethodSet(null);
                    paid_set(normalizeDecimalInput(e.target.value));
                  }}
                  inputRef={paidRef}
                  inputProps={{ ...decimalInputProps, "data-enter-flow": "off" }}
                  onKeyDown={(e) => {
                    if (e.key == "Enter") {
                      e.preventDefault();
                      e.stopPropagation();
                      focusRef(productRef);
                    }
                  }}
                />
              </Grid>

              <Grid item xs={0} sm={1}></Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  type="text"
                  label="Due"
                  variant="outlined"
                  size="small"
                  className={classes.inputField}
                  disabled
                  value={due}
                  name="due"
                  onChange={(e) => due_set(e.target.value)}
                  inputRef={dueRef}
                  inputProps={decimalInputProps}
                  onKeyDown={(e) => {
                    if (e.key == "Enter") {
                      saleRef.current?.click();
                    }
                  }}
                />
              </Grid>
              {paid > 0 ? (
                <Grid
                  item
                  xs={12}
                  sm={5}
                  className={classes.plusLinkDiv}
                  style={{ marginTop: "15px", marginBottom: "10px" }}
                >
                  <Autocomplete
                    style={{ width: "100%" }}
                    options={customerPayMethods}
                    size="small"
                    classes={{
                      option: classes.option,
                    }}
                    autoHighlight={true}
                    openOnFocus={true}
                    getOptionLabel={(option) => option.pay_method}
                    value={selectedCustomerPayMethod}
                    onChange={(event, selectedObj) => {
                      selectedCustomerPayMethodSet(selectedObj);
                      if (
                        selectedObj != null &&
                        selectedObj.pay_method_id == "cash"
                      ) {
                        selectedCustomerPayAccSet(null);
                      }
                    }}
                    loading={customerPayMethods.length == 0 ? true : false}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Payment Method"
                        variant="outlined"
                        inputProps={{
                          ...params.inputProps,
                          endAdornment: (
                            <React.Fragment>
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
                </Grid>
              ) : (
                ""
              )}

              <Grid item xs={12} sm={1}></Grid>

              {paid > 0 ? (
                selectedCustomerPayMethod != null &&
                  selectedCustomerPayMethod.pay_method == "bank" ? (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    className={classes.plusLinkDiv}
                    style={{
                      display:
                        selectedCustomerPayMethod != null &&
                          selectedCustomerPayMethod.pay_method_id == "bank"
                          ? "block"
                          : "none",
                      marginTop: "15px",
                      marginBottom: "10px",
                    }}
                  >
                    <Autocomplete
                      style={{ width: "100%" }}
                      options={customerPayAccs}
                      size="small"
                      classes={{
                        option: classes.option,
                      }}
                      autoHighlight={true}
                      openOnFocus={true}
                      getOptionLabel={(option) => option.bank_display_name}
                      value={selectedCustomerPayAcc}
                      onChange={(event, selectedObj) => {
                        selectedCustomerPayAccSet(selectedObj);
                      }}
                      loading={customerPayAccs.length == 0 ? true : false}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Bank account"
                          variant="outlined"
                          inputProps={{
                            ...params.inputProps,
                            endAdornment: (
                              <React.Fragment>
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                        />
                      )}
                    />
                  </Grid>
                ) : (
                  ""
                )
              ) : (
                ""
              )}
            </Grid>

            <Grid container style={{ paddingRight: "1px" }}>
              <Grid item xs={12} sm={6}>
                <LoadingButton
                  style={{ marginTop: "5px", fontSize: "18px", float: "left" }}
                  variant="contained"
                  color="primary"
                  size="small"
                  loading={saveAction}
                  disabled={saveAction}
                  buttonRef={saleRef}
                  onClick={() => {
                    saleSaveAction();
                  }}
                  className={classes.button}
                  startIcon={<SaveIcon />}
                >
                  Sale
                </LoadingButton>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Button
                  style={{ marginTop: "5px", fontSize: "10px", float: "right" }}
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={resetForm}
                  className={classes.button}
                  startIcon={<SaveIcon />}
                >
                  New Sale
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  inputField: {
    width: "100%",
    marginTop: "5px",
  },
  plusLinkDiv: {
    position: "relative",
  },
  plusLink: {
    margin: 0,
    padding: 0,
    marginTop: "-21px",
    fontSize: "29px",
    height: "21px",
    textAlign: "right",
    position: "absolute",
    right: 0,
    color: "#3e8d54",
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
}));

const mapStateToPops = (state) => {
  return {
    currentRoute: state.currentRouteReducer,
    authInfo: state.authInfoReducer,
  };
};
export default connect(mapStateToPops, { currentRouteSet })(SalesEntry);
